import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Collapse from '@mui/material/Collapse';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import SegmentIcon from '@mui/icons-material/Segment';

import EmailIcon from '@mui/icons-material/Email';

import { 

  Box, 

  Typography, 

  Paper, 

  Button, 

  TextField, 

  List, 

  ListItem, 

  Chip, 

  Stack, 

  CircularProgress, 

  Tooltip, 

  ListItemButton, 

  ListItemText, 

  InputAdornment, 

  IconButton, 

  Table, 

  TableBody, 

  TableCell, 

  TableContainer, 

  TableHead, 

  TableRow,

  Menu,

  MenuItem,

  ListItemIcon,

  Dialog,

  DialogActions,

  DialogContent,

  DialogContentText,

  DialogTitle,

  Pagination,

  Tabs,

  Tab

} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";

import SearchIcon from "@mui/icons-material/Search";

import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

import SendIcon from '@mui/icons-material/Send';

import PersonIcon from '@mui/icons-material/Person';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { api } from '../../services/auth';
import { GREY_UNDEVELOPED_UI, HIDE_INCOMPLETE_FEATURES, API_BASE_URL } from '../../services/config';

import { useNotification } from '../../contexts/NotificationContext';

import { analyzeCampaignPerformance } from '../../services/chatService';

import { getFavorites, addFavorite, removeFavorite } from '../../services/favoriteService';

import { getArchives, addArchive, removeArchive } from '../../services/archiveService';

import MoreVertIcon from '@mui/icons-material/MoreVert';

import DeleteIcon from '@mui/icons-material/Delete';

import ToggleOnIcon from '@mui/icons-material/ToggleOn';

import ToggleOffIcon from '@mui/icons-material/ToggleOff';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import StarIcon from '@mui/icons-material/Star';

import StarBorderIcon from '@mui/icons-material/StarBorder';

import TrendingUpIcon from '@mui/icons-material/TrendingUp';

import ArchiveIcon from '@mui/icons-material/Archive';

import UnarchiveIcon from '@mui/icons-material/Unarchive';

import EditIcon from '@mui/icons-material/Edit';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import Snackbar from '@mui/material/Snackbar';

import Alert from '@mui/material/Alert';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import CloseIcon from '@mui/icons-material/Close';

import RefreshIcon from '@mui/icons-material/Refresh';

import axios from 'axios';

import Joyride, { STATUS, EVENTS } from 'react-joyride';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

// Icons for creation modal
import SmartToyIcon from '@mui/icons-material/SmartToy';
import BuildIcon from '@mui/icons-material/Build';







const Campagne = () => {

  const { showNotification } = useNotification();

  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedCampaignId, setSelectedCampaignId] = useState(null);

  const [updatingCampaignId, setUpdatingCampaignId] = useState(null);

  const [duplicatingCampaignId, setDuplicatingCampaignId] = useState(null);

  const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);

  const [campaignToDuplicate, setCampaignToDuplicate] = useState(null);

  const [newCampaignName, setNewCampaignName] = useState('');

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const [deletingCampaign, setDeletingCampaign] = useState(false);

  const [campaignToSelect, setCampaignToSelect] = useState(null);

  const [segmentCounts, setSegmentCounts] = useState({});
  const [segmentCountsLoading, setSegmentCountsLoading] = useState({});
  const normalizeKey = useCallback((v) => String(v ?? '').trim().toLowerCase(), []);

  const formatNumber = useCallback((value) => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) {
      return '0';
    }
    return new Intl.NumberFormat('fr-FR').format(Number(value));
  }, []);

  const [quotaData, setQuotaData] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchQuotas = async () => {
      try {
        const resp = await api.get('/quotas/me');
        if (!isMounted) return;
        setQuotaData(resp.data);
      } catch (error) {
        if (!isMounted) return;
        console.error('[campagne] Failed to load quota information', error);
      }
    };
    fetchQuotas();
    return () => {
      isMounted = false;
    };
  }, []);

  const quotaScope = quotaData?.plan?.quota_scope || 'user';
  const usageSource = quotaScope === 'brand' ? quotaData?.brand_usage : quotaData?.usage;
  const emailLimit = quotaData?.plan?.emails_included_monthly;
  const emailUsage = usageSource?.emails_sent ?? 0;
  const isEmailQuotaReached = Boolean(emailLimit && emailLimit > 0 && emailUsage >= emailLimit);
  const emailQuotaMessage = useMemo(() => {
    if (!isEmailQuotaReached) return '';
    return `Limite atteinte ❗ Vous avez envoyé ${formatNumber(emailUsage)} emails ce mois-ci, soit la totalité de votre quota. Pour continuer vos envois : Passez à un abonnement supérieur, ou Achetez un pack de surplus email.`;
  }, [isEmailQuotaReached, emailUsage, formatNumber]);

  const handleCreateCampaignRequest = useCallback(
    (allowedAction) => {
      if (isEmailQuotaReached) {
        showNotification(emailQuotaMessage, 'error');
        return;
      }
      if (typeof allowedAction === 'function') {
        allowedAction();
      }
    },
    [isEmailQuotaReached, emailQuotaMessage, showNotification],
  );

  const handleOpenCreateDialog = useCallback(() => {
    try {
      console.log('[campagne] open creation modal');
    } catch (_) {}
    handleCreateCampaignRequest(() => setCreateDialogOpen(true));
  }, [handleCreateCampaignRequest]);



  const handleMenuClose = () => {

    setAnchorEl(null);

    setSelectedCampaignId(null);

  };



  const openDuplicateDialog = (campaignId) => {

    const campaign = campagnes.find(c => c.id === campaignId);

    if (campaign) {

      setCampaignToDuplicate(campaign);

      setNewCampaignName(''); // On ne pré-remplit pas pour forcer un nom unique

      setDuplicateDialogOpen(true);

      handleMenuClose();

    }

  };



  const closeDuplicateDialog = () => {

    setDuplicateDialogOpen(false);

    setCampaignToDuplicate(null);

    setNewCampaignName('');

  };



  const handleDuplicateAndRename = async () => {

    if (!campaignToDuplicate || !newCampaignName.trim()) {

      showNotification('Le nom de la campagne ne peut pas être vide.', 'warning');

      return;

    }

    if (newCampaignName.trim() === campaignToDuplicate.name) {

        showNotification('Veuillez choisir un nom différent de la campagne originale.', 'warning');

        return;

    }



    setDuplicatingCampaignId(campaignToDuplicate.id);



    try {

      // 1. Cloner la campagne

      const cloneResponse = await api.post(`/campaigns/clone/${campaignToDuplicate.id}`);

      

      if (!cloneResponse.data || !cloneResponse.data.success) {

        throw new Error(cloneResponse.data.message || 'Échec du clonage de la campagne.');

      }



      const clonedCampaign = cloneResponse.data.campaign;

      console.log('--- DEBUG DUPLICATION: Objet campagne CLONÉE reçu de l\'API ---', clonedCampaign);



      // 2. Renommer la campagne clonée en utilisant le bon endpoint

      const renameResponse = await api.patch(`/campaigns/${clonedCampaign.id}/rename`, { 

        name: newCampaignName.trim()

      });



      if (!renameResponse.data || !renameResponse.data.success) {

        throw new Error(renameResponse.data.message || 'Échec du renommage de la campagne.');

      }



      // 3. Recharger la page courante (pagination serveur) pour garantir des données fraîches et un total correct.

      const params = new URLSearchParams({

        page: currentPage.toString(),

        page_size: pageSize.toString()

      });

      

      if (search) {

        params.append('search', search);

      }

      

      if (activeFilter === 'favorites') {

        params.append('favorites_only', 'true');

      }

      

      const campaignsResponse = await api.get(`/campaigns?${params.toString()}`);

      if (campaignsResponse.data && campaignsResponse.data.success) {

        const serverCampaigns = Array.isArray(campaignsResponse.data.campaigns) ? campaignsResponse.data.campaigns : [];

        const total = Number(campaignsResponse.data.total || 0);

        setCampagnes(serverCampaigns);

        setTotalCampaigns(total);

        // Mettre à jour le cache minimal (uniquement pour findCampaignById)

        setAllBrandCampaigns(prev => {

          const map = new Map(prev.map(c => [String(c.id), c]));

          serverCampaigns.forEach(c => map.set(String(c.id), c));

          return Array.from(map.values());

        });

        // On utilise un état intermédiaire pour garantir que la sélection se fait après le re-render.

        setCampaignToSelect(clonedCampaign.id);

      } else {

        showNotification('Impossible de rafraîchir la liste, un rechargement manuel peut être nécessaire.', 'warning');

      }

      showNotification('Campagne dupliquée avec succès !');



    } catch (error) {

      console.error("Erreur lors de la duplication et du renommage:", error);

      showNotification(error.message || 'Une erreur est survenue lors de la duplication.', 'error');

      // Idéalement, afficher une notification d'erreur à l'utilisateur ici

    } finally {

      setDuplicatingCampaignId(null);

      closeDuplicateDialog();

    }

  };



  const handleDelete = () => {

    setDeleteDialogOpen(true);

  };



  const confirmDelete = async () => {

    if (!selectedCampaignId) return;



    setDeletingCampaign(true);



    try {

      const response = await api.delete(`/campaigns/${selectedCampaignId}/delete`);



      if (response.data && response.data.success) {

        // Nettoyer la sélection si besoin

        const wasSelected = selected === selectedCampaignId;

        if (wasSelected) {

          setSelected(null);

        }



        // Mettre à jour le total puis recalculer la page à afficher

        const newTotal = Math.max(0, (totalCampaigns || 0) - 1);

        const newTotalPages = Math.max(1, Math.ceil(newTotal / pageSize));

        const nextPage = Math.min(currentPage, newTotalPages);



        // Recharger la page courante depuis le serveur pour rester cohérent

        const params = new URLSearchParams({

          page: nextPage.toString(),

          page_size: pageSize.toString()

        });

        

        if (search) {

          params.append('search', search);

        }

        

        if (activeFilter === 'favorites') {

          params.append('favorites_only', 'true');

        }

        

        const campaignsResponse = await api.get(`/campaigns?${params.toString()}`);

        if (campaignsResponse.data && campaignsResponse.data.success) {

          const serverCampaigns = Array.isArray(campaignsResponse.data.campaigns) ? campaignsResponse.data.campaigns : [];

          const total = Number(campaignsResponse.data.total || newTotal);

          setCampagnes(serverCampaigns);

          setTotalCampaigns(total);

          setCurrentPage(nextPage);

          // Mettre à jour le cache minimal (uniquement pour findCampaignById)

          setAllBrandCampaigns(prev => {

            const map = new Map(prev.map(c => [String(c.id), c]));

            serverCampaigns.forEach(c => map.set(String(c.id), c));

            return Array.from(map.values());

          });

        }



        showNotification('Campagne supprimée avec succès.');

      } else {

        showNotification(response.data.message || 'Erreur lors de la suppression.', 'error');

        console.error('Erreur lors de la suppression de la campagne:', response.data.message);

      }

    } catch (error) {

      showNotification('Erreur API lors de la suppression.', 'error');

      console.error('Erreur API lors de la tentative de suppression:', error);

    } finally {

      setDeletingCampaign(false);

      setDeleteDialogOpen(false);

      handleMenuClose();

    }

  };



  const handleToggleActivate = async (campaignId) => {

    if (!campaignId) return;

    // Chercher la campagne dans toutes les campagnes, pas seulement la page actuelle
    const campaign = findCampaignById(campaignId);
    if (!campaign) return;

    const newStatus = !campaign.isPublished;
    setUpdatingCampaignId(campaignId);

    try {
      const response = await api.patch(`/campaigns/${campaignId}/edit`, { isPublished: newStatus });

      // Si le quota email est dépassé, on bloque l'activation et on affiche un message clair
      if (response.data?.quota_exceeded && response.data?.resource === 'emails') {
        const msg = response.data.message || "Limite atteinte ❗ Vous avez atteint la totalité de votre quota d'emails pour ce mois-ci. Pour continuer vos envois, passez à un abonnement supérieur ou achetez un pack de surplus email.";
        showNotification(msg, 'error');
        // Ne pas mettre à jour l'état local, la campagne reste dans son état actuel
        return;
      }

      if (response.data && response.data.success) {

        // Mettre à jour dans allBrandCampaigns

        setAllBrandCampaigns(prevCampagnes =>

          prevCampagnes.map(c =>

            c.id === campaignId ? { ...c, isPublished: newStatus } : c

          )

        );

        

        // Mettre à jour dans campagnes (page actuelle) si elle y est

        setCampagnes(prevCampagnes =>

          prevCampagnes.map(c =>

            c.id === campaignId ? { ...c, isPublished: newStatus } : c

          )

        );

        

        showNotification(`Campagne ${newStatus ? 'activée' : 'désactivée'} avec succès.`);

      } else {

        showNotification(response.data.message || 'Erreur lors de la mise à jour.', 'error');

        console.error('Erreur lors de la mise à jour de la campagne:', response.data.message);

      }

    } catch (error) {

      showNotification('Erreur API lors de la mise à jour.', 'error');

      console.error('Erreur API lors de la tentative de mise à jour:', error);

    } finally {

      setUpdatingCampaignId(null);

    }

  };



  const [campagnes, setCampagnes] = useState([]);

  const [emails, setEmails] = useState([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);

  const [selected, setSelected] = useState(null);

  const [search, setSearch] = useState("");

  const [searchInput, setSearchInput] = useState("");





  const [iaAnalysis, setIaAnalysis] = useState(null);

  const [iaAnalysisLoading, setIaAnalysisLoading] = useState(false);

  const [iaAnalysisError, setIaAnalysisError] = useState(null);

  // Controller pour annuler l'analyse IA en cours lors d'un changement de sélection
  const iaAbortControllerRef = useRef(null);

  const [isExpanded, setIsExpanded] = useState(false); // Déplié par défaut à false

  const [searchParams, setSearchParams] = useSearchParams();



  // Garder le champ de saisie synchronisé avec la recherche appliquée

  useEffect(() => {

    setSearchInput(search || "");

  }, [search]);



  const handleApplySearch = () => {

    // Applique la recherche uniquement à la validation (bouton/Entrée)

    setSearch(searchInput.trim());

  };

  // Lorsque l'utilisateur efface complètement le champ de recherche,
  // on réinitialise automatiquement la recherche appliquée et on recharge la liste
  useEffect(() => {
    const isInputEmpty = (searchInput || '').trim() === '';
    if (isInputEmpty && search !== '') {
      setSearch('');
      setCurrentPage(1);
      setSelected(null);
    }
  }, [searchInput, search]);



  // Fonction pour construire les paramètres de requête selon le filtre actif

  const buildRequestParams = (page, size, searchTerm, filter) => {

    const params = new URLSearchParams({

      page: page.toString(),

      page_size: size.toString()

    });

    

    // Ajouter les paramètres de tri

    if (sortField && sortDirection) {

      params.append('sort_field', sortField);

      params.append('sort_direction', sortDirection);

    }

    

    if (searchTerm) {

      params.append('search', searchTerm);

    }

    

    // Ajouter les paramètres de filtrage côté serveur

    switch (filter) {

      case 'favorites':

        params.append('favorites_only', 'true');

        break;

      case 'my':

        // Mes campagnes: filtrer par l'utilisateur Mautic courant côté serveur

        params.append('my_only', 'true');

        break;

      case 'draft':

        params.append('where[0][col]', 'isPublished');

        params.append('where[0][expr]', 'eq');

        params.append('where[0][val]', '0');

        break;

      case 'active':

        // Campagnes en cours : actives ET (pas de date de fin OU date de début passée ET date de fin pas encore atteinte)

        // Condition 1: campagne active sans date de fin

        // Condition 2: campagne active avec date de début passée ET date de fin pas encore atteinte

        params.append('where[0][col]', 'isPublished');

        params.append('where[0][expr]', 'eq');

        params.append('where[0][val]', '1');

        // Demander au backend de faire le filtrage 'en cours' côté serveur pour une pagination correcte

        params.append('active_only', 'true');

        break;

      case 'scheduled':

        // Campagnes programmées (publishUp dans le futur)

        params.append('where[0][col]', 'publishUp');

        params.append('where[0][expr]', 'gt');

        params.append('where[0][val]', new Date().toISOString());

        break;

      case 'finished':

        // Campagnes terminées (publishDown dans le passé), indépendamment de isPublished

        params.append('where[0][col]', 'publishDown');

        params.append('where[0][expr]', 'lt');

        params.append('where[0][val]', new Date().toISOString());

        break;

      case 'archived':

        // Campagnes archivées par l'utilisateur

        params.append('archived_only', 'true');

        break;

      default:

        // 'all' et autres filtres: pas de filtrage supplémentaire

        break;

    }

    

    return params;

  };



  const navigate = useNavigate();



  // Pagination states

  const [currentPage, setCurrentPage] = useState(1);

  const [totalCampaigns, setTotalCampaigns] = useState(0);

  const [paginationLoading, setPaginationLoading] = useState(false);

  const [allBrandCampaigns, setAllBrandCampaigns] = useState([]); // Store all brand campaigns

  const [pageSize, setPageSize] = useState(10);

  const PAGE_SIZE_OPTIONS = [5, 10, 15, 20, 25, 30, 50, 100];



  // Sort states

  const [sortField, setSortField] = useState('created'); // created | name | status

  const [sortDirection, setSortDirection] = useState('desc'); // asc | desc



  // Favorites state

  const [favorites, setFavorites] = useState([]);



  // Archives state

  const [archivedItems, setArchivedItems] = useState([]);



  // Load favorites and archives on component mount

  useEffect(() => {

    const loadData = async () => {

      try {

        const [favoritesData, archivesData] = await Promise.all([

          getFavorites('campaign'),

          getArchives('campaign')

        ]);

        setFavorites(favoritesData);

        setArchivedItems(archivesData);

      } catch (error) {

        console.error('Erreur lors du chargement des données:', error);

      }

    };

    

    loadData();

  }, []);



  // Action menu state

  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);

  const [actionMenuOpen, setActionMenuOpen] = useState(false);



  // Notification state

  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });



  // Tab state

  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    const loadSegmentCounts = async () => {
      try {
        const campagne = findCampaignById(selected);
        if (!campagne || !Array.isArray(campagne.lists) || campagne.lists.length === 0) {
          setSegmentCounts({});
          return;
        }
        // Mark all targeted segments as loading
        const keys = campagne.lists
          .map((list) => list?.name || list?.id)
          .filter(Boolean)
          .map((n) => normalizeKey(n));
        setSegmentCountsLoading((prev) => {
          const next = { ...prev };
          keys.forEach((k) => { next[k] = true; });
          return next;
        });

        const entries = await Promise.all(
          campagne.lists.map(async (list) => {
            const displayName = list?.name || list?.id;
            if (!displayName) return [null, 0];
            const requestIdentifier = list?.alias || list?.name || list?.id;
            try {
              console.log('[segments/count] fetching for', requestIdentifier, 'displayKey:', normalizeKey(displayName));
              const resp = await api.get(`/segments/count/${encodeURIComponent(requestIdentifier)}`);
              console.log('[segments/count] response for', requestIdentifier, resp?.data);
              const total = resp?.data?.total ?? 0;
              return [normalizeKey(displayName), Number(total)];
            } catch (e) {
              console.warn('[segments/count] error for', requestIdentifier, e);
              return [normalizeKey(displayName), 0];
            } finally {
              const k = normalizeKey(displayName);
              setSegmentCountsLoading((prev) => ({ ...prev, [k]: false }));
            }
          })
        );
        const map = entries.reduce((acc, [k, v]) => {
          if (k != null) acc[k] = v;
          return acc;
        }, {});
        console.log('[segments/count] final map keys', Object.keys(map));
        setSegmentCounts(map);
      } catch (e) {
        setSegmentCounts({});
        setSegmentCountsLoading({});
      }
    };
    if (selected) {
      loadSegmentCounts();
    }
  }, [selected]);



  // Filter sidebar state

  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);

  const [activeFilter, setActiveFilter] = useState('all');

  // Tour state
  const [runTour, setRunTour] = useState(false);

  

  // Calendar modal state

  const [calendarModalOpen, setCalendarModalOpen] = useState(false);

  const [calendarData, setCalendarData] = useState({});
  const [calendarCampaigns, setCalendarCampaigns] = useState([]);
  const [calendarOngoingNoEnd, setCalendarOngoingNoEnd] = useState([]);

  const [calendarLoading, setCalendarLoading] = useState(false);

  const [currentCalendarDate, setCurrentCalendarDate] = useState(() => {

    const now = new Date();

    return { year: now.getFullYear(), month: now.getMonth() + 1 };

  });

  // Calendar view state and selected date for week/day
  const [calendarView, setCalendarView] = useState('month');
  const [selectedDate, setSelectedDate] = useState(() => new Date());

  // S'assurer que calendarView reste sur 'month' par défaut
  useEffect(() => {
    console.log('Calendar view changed to:', calendarView);
    if (!['month', 'week', 'day'].includes(calendarView)) {
      console.log('Invalid calendar view, resetting to month');
      setCalendarView('month');
    }
  }, [calendarView]);

  // Calendar status filter state (all | active | scheduled | draft | finished)
  const [calendarStatusFilter, setCalendarStatusFilter] = useState('all');
  const statusLabelToId = {
    'En cours': 'active',
    'Programmée': 'scheduled',
    'Brouillon': 'draft',
    'Terminée': 'finished'
  };
  const doesCampaignMatchCalendarFilter = (campaign) => {
    if (calendarStatusFilter === 'all') return true;
    const statut = getCampagneStatus(campaign?.campaign || campaign);
    const statusId = statusLabelToId[statut?.label] || null;
    return statusId === calendarStatusFilter;
  };
  
  // Local view for campaign calendar area (sequence | month)
  const [campaignCalView, setCampaignCalView] = useState('sequence');
  const formatYMD = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
  };
  const getDaysInMonth = (y, m) => new Date(y, m, 0).getDate();
  
  // Creation modal state
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  // Edit Mautic modal state
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editCampaignId, setEditCampaignId] = useState(null);
  const [editIsLoading, setEditIsLoading] = useState(true);
  const [editHasError, setEditHasError] = useState(false);
  const [editCloseConfirmOpen, setEditCloseConfirmOpen] = useState(false);

  const editIframeSrc = useMemo(() => {
    if (!editCampaignId) return null;
    const base = API_BASE_URL || window.location.origin;
    return `${base}/campaigns/mautic/proxy?path=/s/campaigns/edit/${encodeURIComponent(editCampaignId)}`;
  }, [editCampaignId]);

  const requestCloseEditDialog = () => {
    if (!editDialogOpen) return;
    setEditCloseConfirmOpen(true);
  };

  const handleConfirmCloseEditDialog = () => {
    setEditCloseConfirmOpen(false);
    setEditDialogOpen(false);
    setEditCampaignId(null);
  };

  const handleCancelCloseEditDialog = () => {
    setEditCloseConfirmOpen(false);
  };



  // Helper to detect meaningless/empty email names like "Email []" or "[]"
  const isMeaninglessEmailName = (name) => {
    if (!name) return true;
    const s = String(name).trim();
    if (s === '') return true;
    if (/^email\s*\[\s*\]$/i.test(s)) return true;
    if (/^\[\s*\]$/.test(s)) return true;
    return false;
  };

  const sidebarFilters = [

    { id: 'all', label: 'Toutes les campagnes', icon: <SendIcon />, color: 'default' },

    { id: 'my', label: 'Mes campagnes', icon: <PersonIcon />, color: 'default' },

    { id: 'favorites', label: 'Favoris', icon: <StarBorderIcon />, color: 'default' },

    { id: 'calendar', label: 'Calendrier', icon: <CalendarTodayIcon />, color: 'default' },

    { id: 'archived', label: 'Archivées', icon: <ArchiveIcon />, color: 'default' },

  ];



  const statusFilters = [

    { id: 'active', label: 'En cours', color: '#10B981' },

    { id: 'scheduled', label: 'Programmée', color: '#3B82F6' },

    { id: 'draft', label: 'Brouillon', color: '#F59E0B' },

    { id: 'finished', label: 'Terminée', color: '#6B7280' },

  ];



  const loadCalendarData = async (year, month) => {

    try {

      setCalendarLoading(true);

      const response = await api.get(`/campaigns/calendar?year=${year}&month=${month}`);

      if (response.data && response.data.success) {

        setCalendarData(response.data.calendar_data || {});

        setCalendarCampaigns(response.data.campaigns || []);

        setCalendarOngoingNoEnd(response.data.ongoing_no_end || []);

      }

    } catch (error) {

      console.error('Erreur lors du chargement des données du calendrier:', error);

      showNotification('Erreur lors du chargement des données du calendrier', 'error');

    } finally {

      setCalendarLoading(false);

    }

  };



  const handleCalendarNavigation = (direction) => {
    try { console.log('[campagne] handleCalendarNavigation', direction); } catch(_) {}

    let { year, month } = currentCalendarDate;

    

    if (direction === 'prev') {

      if (month === 1) {

        month = 12;

        year--;

      } else {

        month--;

      }

    } else if (direction === 'next') {

      if (month === 12) {

        month = 1;

        year++;

      } else {

        month++;

      }

    }

    

    // Synchroniser la date sélectionnée (utilisée ailleurs) avec le mois affiché
    setSelectedDate(new Date(year, month - 1, 1));
    setCurrentCalendarDate({ year, month });
  };



  const handleCalendarToday = () => {
    try { console.log('[campagne] handleCalendarToday'); } catch(_) {}

    const now = new Date();

    const year = now.getFullYear();

    const month = now.getMonth() + 1;

    setSelectedDate(new Date(year, month - 1, 1));
    setCurrentCalendarDate({ year, month });
  };

  // Recharger automatiquement les données quand le mois affiché change
  useEffect(() => {
    // Nettoyer l'ancien jeu de données pour éviter un affichage trompeur pendant le chargement
    setCalendarData({});
    loadCalendarData(currentCalendarDate.year, currentCalendarDate.month);
  }, [currentCalendarDate.year, currentCalendarDate.month]);



  const generateCalendarDays = (year, month) => {
    const formatDateLocal = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    };

    const firstDay = new Date(year, month - 1, 1);

    const startDate = new Date(firstDay);

    startDate.setDate(startDate.getDate() - firstDay.getDay());

    

    const days = [];

    for (let i = 0; i < 42; i++) {

      const currentDate = new Date(startDate);

      currentDate.setDate(startDate.getDate() + i);

      

      const dayKey = formatDateLocal(currentDate);

      const isCurrentMonth = currentDate.getMonth() === month - 1;

      // Surligner aujourd'hui uniquement si visible dans le mois affiché
      const isToday = isCurrentMonth && currentDate.toDateString() === new Date().toDateString();

      

      days.push({

        date: currentDate,

        day: currentDate.getDate(),

        isCurrentMonth,

        isToday,

        dayKey,

        campaigns: calendarData[dayKey] || []

      });

    }

    

    return days;

  };



  const handleFilterChange = (filterId) => {
    try { console.log('[campagne] handleFilterChange', filterId); } catch(_) {}

    if (filterId === 'calendar') {

      setCalendarModalOpen(true);

      // Charger les données du calendrier quand on ouvre la modal

      loadCalendarData(currentCalendarDate.year, currentCalendarDate.month);

      return;

    }

    

    // Si on passe au filtre favoris et qu'il n'y a pas de favoris, optimiser

    if (filterId === 'favorites' && favorites.length === 0) {

      setActiveFilter(filterId);

      setCurrentPage(1);

      setSelected(null);

      setCampagnes([]);

      setAllBrandCampaigns([]);

      setTotalCampaigns(0);

      return;

    }

    

    setActiveFilter(filterId);

    setCurrentPage(1); // Reset to first page when filter changes

    setSelected(null); // Désélectionner toute campagne lors du changement de filtre

  };



  // Helper functions for pagination and favorites

  const isFavorite = useCallback((campaignId) => {

    return favorites.some(fav => fav.data_id === campaignId);

  }, [favorites]);



  // Helper function to check if a campaign is archived

  const isArchived = useCallback((campaignId) => {

    return archivedItems.some(arch => arch.data_id === campaignId);

  }, [archivedItems]);



  const handlePageSizeChange = (e) => {
    try { console.log('[campagne] handlePageSizeChange', e?.target?.value); } catch(_) {}

    const newSize = Number(e.target.value);

    setPageSize(newSize);

    setCurrentPage(1);

    setSelected(null); // Désélectionner toute campagne lors du changement de taille de page

    // L'effet useEffect([pageSize, activeFilter, search, searchParams]) s'occupe du fetch

  };







  const handlePageChange = async (event, newPage) => {
    try { console.log('[campagne] handlePageChange', newPage); } catch(_) {}

    if (newPage === currentPage) return;

    setPaginationLoading(true);

    setSelected(null); // Désélectionner toute campagne lors du changement de page

    try {

      const params = buildRequestParams(newPage, pageSize, search, activeFilter);

      

      const resp = await api.get(`/campaigns?${params.toString()}`);

      if (resp.data && resp.data.success) {

        const serverCampaigns = Array.isArray(resp.data.campaigns) ? resp.data.campaigns : [];

        const total = Number(resp.data.total || 0);

        setCampagnes(serverCampaigns);

        setTotalCampaigns(total);

        setCurrentPage(newPage);

        // mettre à jour le cache global minimal

        setAllBrandCampaigns(prev => {

          const map = new Map(prev.map(c => [String(c.id), c]));

          serverCampaigns.forEach(c => map.set(String(c.id), c));

          return Array.from(map.values());

        });

      } else {

        throw new Error('Réponse inattendue du serveur');

      }

    } catch (err) {

      console.error('Erreur lors du changement de page:', err);

      setError('Erreur lors du changement de page.');

    } finally {

      setPaginationLoading(false);

    }

  };



  const handleToggleFavorite = async (campaignId) => {
    try { console.log('[campagne] toggleFavorite', campaignId); } catch(_) {}

    try {

      if (isFavorite(campaignId)) {

        await removeFavorite('campaign', campaignId);

        setFavorites(favorites.filter(fav => fav.data_id !== campaignId));

      } else {

        const newFav = await addFavorite('campaign', campaignId);

        setFavorites([...favorites, newFav]);

      }



      // Si on est sur le filtre "favorites", recharger la page pour refléter les changements

      if (activeFilter === 'favorites') {

        // Si on vient de retirer le dernier favori, vider la liste sans faire de requête

        if (isFavorite(campaignId) && favorites.length === 1) {

          setCampagnes([]);

          setAllBrandCampaigns([]);

          setTotalCampaigns(0);

          setCurrentPage(1);

          setSelected(null);

          return;

        }

        try {

          setPaginationLoading(true);

          const params = buildRequestParams(1, pageSize, search, 'favorites');

          

          const resp = await api.get(`/campaigns?${params.toString()}`);

          if (resp.data && resp.data.success) {

            const serverCampaigns = Array.isArray(resp.data.campaigns) ? resp.data.campaigns : [];

            const total = Number(resp.data.total || 0);

            setCampagnes(serverCampaigns);

            setTotalCampaigns(total);

            setCurrentPage(1);

            // Mettre à jour le cache minimal (uniquement pour findCampaignById)

            setAllBrandCampaigns(prev => {

              const map = new Map(prev.map(c => [String(c.id), c]));

              serverCampaigns.forEach(c => map.set(String(c.id), c));

              return Array.from(map.values());

            });

          }

        } catch (e) {

          console.error('Erreur lors du rechargement après modification des favoris:', e);

        } finally {

          setPaginationLoading(false);

        }

      }

    } catch (error) {

      console.error('Erreur lors de la mise à jour des favoris:', error);

      showNotification('Erreur lors de la mise à jour des favoris', 'error');

    }

  };



  const handleArchiveCampaign = async (campaignId) => {
    try { console.log('[campagne] archive', campaignId); } catch(_) {}

    if (!campaignId) return;

    

    try {

      await addArchive('campaign', campaignId);

      setArchivedItems(prev => [...prev, { data_type: 'campaign', data_id: campaignId }]);

      

      // Retirer de la liste visible immédiatement

      setCampagnes(prev => prev.filter(c => c.id !== campaignId));

      

      // Mettre à jour le total pour corriger la pagination

      const newTotal = Math.max(0, totalCampaigns - 1);

      setTotalCampaigns(newTotal);

      

      // Si la page devient vide et qu'il y a des pages précédentes, aller à la page précédente

      const remainingCampaigns = campagnes.filter(c => c.id !== campaignId);

      if (remainingCampaigns.length === 0 && currentPage > 1 && newTotal > 0) {

        const newPage = Math.max(1, currentPage - 1);

        setCurrentPage(newPage);

        

        // Recharger la page précédente

        const params = buildRequestParams(newPage, pageSize, search, activeFilter);

        const resp = await api.get(`/campaigns?${params.toString()}`);

        if (resp.data && resp.data.success) {

          const serverCampaigns = Array.isArray(resp.data.campaigns) ? resp.data.campaigns : [];

          setCampagnes(serverCampaigns);

          // Mettre à jour le cache minimal

          setAllBrandCampaigns(prev => {

            const map = new Map(prev.map(c => [String(c.id), c]));

            serverCampaigns.forEach(c => map.set(String(c.id), c));

            return Array.from(map.values());

          });

        }

      }

      

      if (selected === campaignId) setSelected(null);

      

      showNotification('Campagne archivée avec succès', 'success');

    } catch (error) {

      console.error('Erreur lors de l\'archivage:', error);

      showNotification('Erreur lors de l\'archivage', 'error');

    }

  };



  const handleRestoreCampaign = async (campaignId) => {
    try { console.log('[campagne] restore', campaignId); } catch(_) {}

    if (!campaignId) return;

    

    try {

      await removeArchive('campaign', campaignId);

      setArchivedItems(prev => prev.filter(arch => String(arch.data_id) !== String(campaignId)));

      

      // Recharger les données pour mettre à jour la pagination

      const params = buildRequestParams(currentPage, pageSize, search, activeFilter);

      const resp = await api.get(`/campaigns?${params.toString()}`);

      if (resp.data && resp.data.success) {

        const serverCampaigns = Array.isArray(resp.data.campaigns) ? resp.data.campaigns : [];

        const total = Number(resp.data.total || 0);

        setCampagnes(serverCampaigns);

        setTotalCampaigns(total);

        // Mettre à jour le cache minimal (uniquement pour findCampaignById)

        setAllBrandCampaigns(prev => {

          const map = new Map(prev.map(c => [String(c.id), c]));

          serverCampaigns.forEach(c => map.set(String(c.id), c));

          return Array.from(map.values());

        });

      }

      

      showNotification('Campagne restaurée avec succès', 'success');

    } catch (error) {

      console.error('Erreur lors de la restauration:', error);

      showNotification('Erreur lors de la restauration', 'error');

    }

  };



  const handleActionMenuOpen = (event) => {
    try { console.log('[campagne] open action menu'); } catch(_) {}

    setActionMenuAnchor(event.currentTarget);

    setActionMenuOpen(true);

  };



  const handleActionMenuClose = () => {
    try { console.log('[campagne] close action menu'); } catch(_) {}

    setActionMenuAnchor(null);

    setActionMenuOpen(false);

  };



  const handleCloseNotification = () => {

    setNotification({ ...notification, open: false });

  };



  const handleTabChange = (event, newValue) => {
    try { console.log('[campagne] change tab', newValue); } catch(_) {}

    setTabValue(newValue);

  };



  // Fonction helper pour trouver une campagne par ID (page actuelle + toutes les campagnes)

  const findCampaignById = useCallback((campaignId) => {

    if (!campaignId) return null;

    

    // D'abord chercher dans la page actuelle

    let campaign = campagnes.find(c => c.id === campaignId);

    

    // Si pas trouvé, chercher dans toutes les campagnes

    if (!campaign) {

      campaign = allBrandCampaigns.find(c => c.id === campaignId);

    }

    

    return campaign;

  }, [campagnes, allBrandCampaigns]);

  // Load real emails of selected campaign for Calendar tab
  const [campaignEmails, setCampaignEmails] = useState([]);
  const [campaignSchedules, setCampaignSchedules] = useState([]);
  const [campaignEmailsLoading, setCampaignEmailsLoading] = useState(false);
  const [emailsLoadedForCampaignId, setEmailsLoadedForCampaignId] = useState(null);
  // Cache id -> meta (name, subject) pour nommer les emails dans les stats
  const [emailNamesById, setEmailNamesById] = useState({});
  const [workflowLoading, setWorkflowLoading] = useState(false);
  
  // Effect to handle workflow loading when campaign is selected
  useEffect(() => {
    if (selected && tabValue === 4) {
      setWorkflowLoading(true);
    }
  }, [selected, tabValue]);
  
  useEffect(() => {
    const loadEmails = async () => {
      try {
        const camp = findCampaignById(selected);
        if (!selected || !camp) {
          setCampaignEmails([]);
          setCampaignSchedules([]);
          setEmailsLoadedForCampaignId(null);
          return;
        }
        if (emailsLoadedForCampaignId && String(emailsLoadedForCampaignId) === String(selected)) {
          return; // already loaded for this campaign
        }
        setCampaignEmailsLoading(true);
        const resp = await api.get(`/campaigns/emails/${encodeURIComponent(selected)}`);
        const emails = Array.isArray(resp?.data?.emails) ? resp.data.emails : [];
        const scheduled = Array.isArray(resp?.data?.scheduled) ? resp.data.scheduled : [];
        setCampaignEmails(emails);
        setCampaignSchedules(scheduled);
        // Construire un cache id -> nom/sujet pour affichage des stats
        const map = {};
        emails.forEach(e => {
          if (!e || e.id == null) return;
          map[String(e.id)] = {
            name: e.name || e.subject || `Email ${e.id}`,
            subject: e.subject
          };
        });
        setEmailNamesById(map);
        setEmailsLoadedForCampaignId(selected);
      } catch (e) {
        setCampaignEmails([]);
        setCampaignSchedules([]);
        setEmailsLoadedForCampaignId(null);
      } finally {
        setCampaignEmailsLoading(false);
      }
    };
    if (selected) {
      loadEmails();
    }
  }, [selected, findCampaignById, emailsLoadedForCampaignId]);



  // Hook pour gérer l'analyse IA lorsqu'une campagne est sélectionnée

  useEffect(() => {

    const selectedCampaign = findCampaignById(selected);

    // Annuler toute analyse en cours avant d'en lancer une nouvelle
    if (iaAbortControllerRef.current) {
      try { iaAbortControllerRef.current.abort(); } catch {}
      iaAbortControllerRef.current = null;
    }

    if (selected && selectedCampaign) {
      const controller = new AbortController();
      iaAbortControllerRef.current = controller;

      const analyze = async () => {

        setIaAnalysisLoading(true);

        setIaAnalysis(null);

        setIaAnalysisError(null);



        try {

          const analysis = await analyzeCampaignPerformance(

            `Analyse complète de la performance de la campagne "${selectedCampaign.name}"`,

            { signal: controller.signal }

          );



          if (controller.signal.aborted) return;

          // Détection d'un retour d'erreur côté service (sans throw) lié au quota Google/rate limit
          if (analysis && analysis.success === false) {
            const backendMsg = String(analysis.message || analysis.error || '');
            if (/quota|exceeded|rate limit|429|too many requests/i.test(backendMsg)) {
              const quotaMsg = "Le quota Google est atteint (erreur 429). Veuillez réessayer plus tard ou changer de fournisseur/modèle.";
              setIaAnalysisError(quotaMsg);
              showNotification(quotaMsg, 'warning');
              return;
            }
          }



          const rawText = analysis?.campaign_analysis_text || '';

          const cleanedText = rawText.replace(/Cordialement,.*$/s, '').replace(/L'équipe de marketing.*$/s, '');

          const sections = {

            evaluation: cleanedText.match(/(1\.\s*)?(Evaluation globale|Analyse globale)[\s\S]*?(?=\n\n\d\.|$)/s)?.[0] || 'Non disponible',

            indicateurs: cleanedText.match(/(2\.\s*)?(Analyse des indicateurs clés|Indicateurs clés|Statistiques clés)[\s\S]*?(?=\n\n\d\.|$)/s)?.[0] || 'Non disponible',

            benchmarks: cleanedText.match(/(3\.\s*)?(Comparaison aux benchmarks|Benchmark)["\s\S]*?(?=\n\n\d\.|$)/s)?.[0] || 'Non disponible',

            recommandations: cleanedText.match(/(5\.\s*)?(Recommandations)[\s\S]*?(?=\n\n\d\.|$)/s)?.[0] || 'Non disponible',

            pointsSection: cleanedText.match(/(6\.\s*)?(Points forts et points faibles|Points forts et faibles|Forces et Faiblesses|Identification)[\s\S]*?$/s)?.[0] || 'Non disponible'

          };



          const cleanSection = (text) => {

              if (!text || text === 'Non disponible') return 'Non disponible';

              let cleaned = text.replace(/^\d+\.\s*.*\n/, '').trim();

              if (cleaned === text.trim()) { cleaned = cleaned.replace(/^\d+\.\s*/, '').trim(); }

              const titles = ["Evaluation globale", "Analyse globale", "Indicateurs clés", "Recommandations","Points forts et points faibles","Comparaison aux benchmarks du secteur"];

              const titleRegex = new RegExp(`^(${titles.join('|')})\\s*[:\\-]?\\s*`, 'i');

              cleaned = cleaned.replace(titleRegex, '').trim();

              cleaned = cleaned.replace(/^\s*\* /gm, '• ');

              cleaned = cleaned.replace(/^\s*- /gm, '• ');

              cleaned = cleaned.replace(/\n\n+/g, '\n').trim();

              return cleaned;

          };



          const analysisData = {

              rawText,

              evaluation: cleanSection(sections.evaluation),

              indicateurs: cleanSection(sections.indicateurs),

              benchmarks: cleanSection(sections.benchmarks),

              recommandations: cleanSection(sections.recommandations),

              pointsSection: cleanSection(sections.pointsSection),

              statistics: analysis.statistics,

          };



          setIaAnalysis(analysisData);



        } catch (error) {

          if (!axios.isCancel(error)) {

            console.error("Erreur lors de l'analyse IA:", error);

            const status = error?.response?.status;
            const detail = String(error?.response?.data?.detail || error?.response?.data?.message || error?.message || '');
            if (status === 429 || /quota|exceeded your current quota|rate limit|429|too many requests/i.test(detail)) {
              const quotaMsg = "Le quota Google est atteint (erreur 429). Veuillez réessayer plus tard ou changer de fournisseur/modèle.";
              setIaAnalysisError(quotaMsg);
              showNotification(quotaMsg, 'warning');
            } else {
              setIaAnalysisError("Une erreur est survenue lors de l'analyse.");
            }

          }

        } finally {

          if (!controller.signal.aborted) {

            setIaAnalysisLoading(false);

          }

        }

      };



      analyze();



      return () => {

        try { controller.abort(); } catch {}
        if (iaAbortControllerRef.current === controller) {
          iaAbortControllerRef.current = null;
        }

      };

    } else {

      setIaAnalysis(null);

      setIaAnalysisError(null);

      setIaAnalysisLoading(false);

    }

  }, [selected, campagnes, findCampaignById]);



  // Actualisation manuelle de l'analyse IA (aligné avec la page Segment)
  const handleRefreshIaAnalysis = async () => {
    if (!selected) return;
    const selectedCampaign = findCampaignById(selected);
    if (!selectedCampaign) return;

    // Annuler toute analyse en cours avant d'en relancer une
    if (iaAbortControllerRef.current) {
      try { iaAbortControllerRef.current.abort(); } catch {}
      iaAbortControllerRef.current = null;
    }

    setIaAnalysisLoading(true);
    setIaAnalysis(null);
    setIaAnalysisError(null);

    try {
      const analysis = await analyzeCampaignPerformance(
        `Analyse complète de la performance de la campagne "${selectedCampaign.name}"`
      );

      if (analysis && analysis.success === false) {
        const backendMsg = String(analysis.message || analysis.error || '');
        if (/quota|exceeded|rate limit|429|too many requests/i.test(backendMsg)) {
          const quotaMsg = "Le quota Google est atteint (erreur 429). Veuillez réessayer plus tard ou changer de fournisseur/modèle.";
          setIaAnalysisError(quotaMsg);
          showNotification(quotaMsg, 'warning');
          setIaAnalysisLoading(false);
          return;
        }
      }

      const rawText = analysis?.campaign_analysis_text || '';
      const cleanedText = rawText.replace(/Cordialement,.*$/s, '').replace(/L'équipe de marketing.*$/s, '');
      const sections = {
        evaluation: cleanedText.match(/(1\.\s*)?(Evaluation globale|Analyse globale)[\s\S]*?(?=\n\n\d\.|$)/s)?.[0] || 'Non disponible',
        indicateurs: cleanedText.match(/(2\.\s*)?(Analyse des indicateurs clés|Indicateurs clés|Statistiques clés)[\s\S]*?(?=\n\n\d\.|$)/s)?.[0] || 'Non disponible',
        benchmarks: cleanedText.match(/(3\.\s*)?(Comparaison aux benchmarks|Benchmark)["\s\S]*?(?=\n\n\d\.|$)/s)?.[0] || 'Non disponible',
        recommandations: cleanedText.match(/(5\.\s*)?(Recommandations)[\s\S]*?(?=\n\n\d\.|$)/s)?.[0] || 'Non disponible',
        pointsSection: cleanedText.match(/(6\.\s*)?(Points forts et points faibles|Points forts et faibles|Forces et Faiblesses|Identification)[\s\S]*?$/s)?.[0] || 'Non disponible'
      };

      const cleanSection = (text) => {
        if (!text || text === 'Non disponible') return 'Non disponible';
        let cleaned = text.replace(/^\d+\.\s*.*\n/, '').trim();
        if (cleaned === text.trim()) { cleaned = cleaned.replace(/^\d+\.\s*/, '').trim(); }
        const titles = ["Evaluation globale", "Analyse globale", "Indicateurs clés", "Recommandations","Points forts et points faibles","Comparaison aux benchmarks du secteur"];
        const titleRegex = new RegExp(`^(${titles.join('|')})\\s*[:\\-]?\\s*`, 'i');
        cleaned = cleaned.replace(titleRegex, '').trim();
        cleaned = cleaned.replace(/^\s*\* /gm, '• ');
        cleaned = cleaned.replace(/^\s*- /gm, '• ');
        cleaned = cleaned.replace(/\n\n+/g, '\n').trim();
        return cleaned;
      };

      const analysisData = {
        rawText,
        evaluation: cleanSection(sections.evaluation),
        indicateurs: cleanSection(sections.indicateurs),
        benchmarks: cleanSection(sections.benchmarks),
        recommandations: cleanSection(sections.recommandations),
        pointsSection: cleanSection(sections.pointsSection),
        statistics: analysis.statistics,
      };

      setIaAnalysis(analysisData);
    } catch (error) {
      if (!axios.isCancel(error)) {
        const status = error?.response?.status;
        const detail = String(error?.response?.data?.detail || error?.response?.data?.message || error?.message || '');
        if (status === 429 || /quota|exceeded your current quota|rate limit|429|too many requests/i.test(detail)) {
          const quotaMsg = "Le quota Google est atteint (erreur 429). Veuillez réessayer plus tard ou changer de fournisseur/modèle.";
          setIaAnalysisError(quotaMsg);
          showNotification(quotaMsg, 'warning');
        } else {
          setIaAnalysisError("Une erreur est survenue lors de l'analyse.");
        }
      }
    } finally {
      setIaAnalysisLoading(false);
    }
  };



   // Gère la sélection post-duplication pour éviter les race conditions

  useEffect(() => {

    if (campaignToSelect && campagnes.some(c => c.id === campaignToSelect)) {

      setSelected(campaignToSelect);

      setCampaignToSelect(null); // On réinitialise pour éviter les re-sélections inutiles

    }

  }, [campaignToSelect, campagnes]);



  // Synchronise la sélection quand les paramètres d'URL changent (id, highlight, name)

  useEffect(() => {

    if (!campagnes || campagnes.length === 0) return;



    const idParam = searchParams.get('id');

    const highlightId = searchParams.get('highlight');

    const nameParam = searchParams.get('name');



    let next = null;

    if (idParam) {

      next = campagnes.find(c => String(c.id) === String(idParam));

    } else if (highlightId) {

      next = campagnes.find(c => String(c.id) === String(highlightId));

    } else if (nameParam) {

      const nameLc = nameParam.toLowerCase();

      next = campagnes.find(c => (c.name || '').toLowerCase() === nameLc);

    }



    if (next && selected !== next.id) {

      setSelected(next.id);

    }

  }, [searchParams, campagnes, selected]);





  useEffect(() => {

    const fetchData = async () => {

      setLoading(true);

      setError(null);

      try {

        // Si le filtre favoris est actif et qu'il n'y a pas de favoris, ne pas faire la requête

        if (activeFilter === 'favorites' && favorites.length === 0) {

          setCampagnes([]);

          setAllBrandCampaigns([]);

          setTotalCampaigns(0);

          setCurrentPage(1);

          setSelected(null);

          return;

        }

        // Charger les campagnes (page 1) + emails + favoris en parallèle

        const params = buildRequestParams(1, pageSize, search, activeFilter);

        

        const campaignsResponse = await api.get(`/campaigns?${params.toString()}`);



        // Traiter les campagnes (paginated from server)

        if (campaignsResponse.data && campaignsResponse.data.success && Array.isArray(campaignsResponse.data.campaigns)) {

          const fetchedCampagnes = campaignsResponse.data.campaigns;

          const total = Number(campaignsResponse.data.total || fetchedCampagnes.length);



          setCampagnes(fetchedCampagnes);

          setCurrentPage(1);

          setTotalCampaigns(total);

          // Clear global cache to rely on server pagination

          setAllBrandCampaigns([]);



          const idParam = searchParams.get('id');

          const highlightId = searchParams.get('highlight');

          const campaignToSelect = highlightId ? fetchedCampagnes.find(c => c.id === parseInt(highlightId)) : null;



          if (campaignToSelect) {

            setSelected(campaignToSelect.id);

          }

          // Suppression de la sélection automatique de la première campagne

        } else {

          setCampagnes([]);

          setAllBrandCampaigns([]);

          setTotalCampaigns(0);

          setError('Aucune campagne trouvée ou format inattendu.');

        }



        // Ne pas charger les modèles d'emails au montage pour éviter des requêtes supplémentaires

        setEmails([]);



      } catch (e) {

        if (e.response && e.response.status === 400 && e.response.data && e.response.data.detail && e.response.data.detail.includes('paramètre Mautic')) {

          setError("Aucun paramètre Mautic n'est associé à votre compte. Veuillez contacter un administrateur pour configurer votre accès Mautic.");

        } else {

          setError(e.message || 'Erreur lors de la récupération des données');

        }

        setCampagnes([]);

        setAllBrandCampaigns([]);

        setTotalCampaigns(0);

        setEmails([]);

      } finally {

        setLoading(false);

      }

    };

    fetchData();

  }, [pageSize, activeFilter, search, searchParams, sortField, sortDirection]); // <-- Dépendances pour recharger si nécessaire



  // Recherche globale côté serveur: refetch page 1 quand la recherche change (avec debounce)

  useEffect(() => {

    if (!search || search.trim() === '') {

      return;

    }

    const timer = setTimeout(async () => {

      try {

        setPaginationLoading(true);

        setSelected(null); // Désélectionner toute campagne lors de la recherche

        const params = buildRequestParams(1, pageSize, search, activeFilter);

        

        const resp = await api.get(`/campaigns?${params.toString()}`);

        if (resp.data && resp.data.success) {

          const serverCampaigns = Array.isArray(resp.data.campaigns) ? resp.data.campaigns : [];

          const total = Number(resp.data.total || 0);

          setCampagnes(serverCampaigns);

          setTotalCampaigns(total);

          setCurrentPage(1);

          // Mettre à jour le cache minimal (uniquement pour findCampaignById)

          setAllBrandCampaigns(prev => {

            const map = new Map(prev.map(c => [String(c.id), c]));

            serverCampaigns.forEach(c => map.set(String(c.id), c));

            return Array.from(map.values());

          });

        }

      } catch (e) {

        console.error('Erreur lors de la recherche côté serveur:', e);

      } finally {

        setPaginationLoading(false);

      }

    }, 300);

    return () => clearTimeout(timer);

  }, [search, pageSize, activeFilter, sortField, sortDirection]);



  

  // Déduction du statut métier selon le template HTML

const getCampagneStatus = (c) => {
    const now = new Date();
    const publishUp = c.publishUp ? new Date(c.publishUp) : null;
    const publishDown = c.publishDown ? new Date(c.publishDown) : null;

    // Si la date de fin est passée, c'est terminée (prioritaire sur tout le reste)
    if (publishDown && publishDown < now) {
        return { label: 'Terminée', color: '#6B7280' };
    }

    // Si isPublished est false, c'est un brouillon
    if (!c.isPublished) {
        return { label: 'Brouillon', color: '#F59E0B' };
    }

    // Si isPublished est true mais la date de début est dans le futur, c'est programmée
    if (publishUp && publishUp > now) {
        return { label: 'Programmée', color: '#3B82F6' };
    }

    // Si isPublished est true et qu'on est dans la période active, c'est en cours
    // Cela inclut les campagnes sans dates ou avec des dates valides
    return { label: 'En cours', color: '#10B981' };
  };

  

// Fonction utilitaire pour obtenir le label du statut métier

const getCampagneStatusLabel = (c) => getCampagneStatus(c).label;











// Avec la pagination serveur, utiliser les campagnes telles que renvoyées par l'API (le backend gère 'active_only')

const displayCampaigns = campagnes;



// Avec la pagination serveur, on n'effectue aucun slice supplémentaire



// Réinitialiser la page si la page courante devient invalide (basée sur le total serveur)

useEffect(() => {

  const pages = Math.ceil((totalCampaigns || 0) / pageSize) || 1;

  if (currentPage > pages) {

    setCurrentPage(1);

  }

}, [search, activeFilter, totalCampaigns, currentPage, pageSize]);



const totalPages = Math.ceil((totalCampaigns || 0) / pageSize) || 1;



















  // Tour steps configuration
  const tourSteps = useMemo(() => [
    {
      target: '[data-tourid="filter-sidebar-toggle"]',
      content: 'Utilisez ce bouton pour afficher ou masquer le panneau des filtres et statuts.',
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tourid="sidebar-navigation-filters"]',
      content: 'Utilisez ces filtres de navigation pour afficher toutes les campagnes, vos campagnes, favoris, calendrier ou archivées. Cliquez sur un filtre pour l\'activer.',
      placement: 'right',
    },
    {
      target: '[data-tourid="sidebar-status-filters"]',
      content: 'Utilisez ces filtres de statut pour afficher les campagnes en cours, programmées, brouillons ou terminées. Chaque statut est représenté par une couleur.',
      placement: 'right',
    },
    {
      target: '[data-tourid="new-campaign-button"]',
      content: 'Cliquez ici pour créer une nouvelle campagne. Vous pouvez choisir entre une création assistée par IA ou une création manuelle.',
      placement: 'bottom',
    },
    {
      target: '[data-tourid="search-campaigns"]',
      content: 'Utilisez cette barre de recherche pour trouver rapidement une campagne spécifique par son nom.',
      placement: 'bottom',
    },
    {
      target: '[data-tourid="sort-campaigns"]',
      content: 'Triez vos campagnes par date de création, date de modification ou nom. Utilisez la flèche pour inverser l\'ordre.',
      placement: 'bottom',
    },
    {
      target: '[data-tourid="campaigns-list"]',
      content: 'Voici la liste de toutes vos campagnes. Cliquez sur une campagne pour voir ses détails. Utilisez les icônes pour activer/désactiver, archiver ou supprimer.',
      placement: 'right',
    },
    {
      target: '[data-tourid="campaign-details"]',
      content: 'Cette zone affiche les détails de la campagne sélectionnée : analyse IA, performances, configuration, calendrier et workflow. Utilisez les onglets pour naviguer entre les différentes sections.',
      placement: 'left',
    },
    {
      target: '[data-tourid="pagination"]',
      content: 'Utilisez la pagination pour naviguer entre les pages de campagnes. Vous pouvez également modifier le nombre d\'éléments par page.',
      placement: 'top',
    },
  ], []);

  // Handle tour callbacks
  const handleTourCallback = useCallback((data) => {
    const { status, type, index, action } = data;
    
    console.log('Tour callback:', { status, type, index, action, step: tourSteps[index]?.target });
    
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      setRunTour(false);
      // Save to localStorage that user has completed the tour
      localStorage.setItem('campagne-tour-completed', 'true');
    } else if (type === EVENTS.STEP_BEFORE) {
      // Ensure sidebar is open for steps that require it (should already be open from tour start)
      if ((index === 1 || index === 2) && !isFilterSidebarOpen) {
        setIsFilterSidebarOpen(true);
      }
    } else if (type === EVENTS.TARGET_NOT_FOUND) {
      // If target not found, log it but let joyride handle it
      console.warn('Target not found for step', index, 'target:', tourSteps[index]?.target);
    }
  }, [tourSteps, isFilterSidebarOpen]);

  // Check if user has completed tour before, and offer to restart
  useEffect(() => {
    const tourCompleted = localStorage.getItem('campagne-tour-completed');
    // Auto-start tour for first-time users
    if (!tourCompleted) {
      // Open sidebar before starting tour to ensure elements are in DOM
      if (!isFilterSidebarOpen) {
        setIsFilterSidebarOpen(true);
      }
      // Wait a bit longer to ensure sidebar is fully rendered
      setTimeout(() => setRunTour(true), 1500);
    }
  }, [isFilterSidebarOpen]);

  return (

    <Box sx={{ display: 'flex', height: '85vh', gap: 0, mx: 3, mt: 0, mb: 3 }}>

      {/* Joyride Tour Component */}
      <Joyride
        steps={tourSteps}
        run={runTour}
        continuous={true}
        showProgress={true}
        showSkipButton={true}
        callback={handleTourCallback}
        disableOverlayClose={false}
        disableScrolling={false}
        spotlightClicks={false}
        floaterProps={{
          disableAnimation: false,
        }}
        scrollOffset={20}
        styles={{
          options: {
            primaryColor: '#007B8A',
            zIndex: 10000,
          },
          tooltip: {
            borderRadius: 8,
            fontFamily: 'Montserrat, Arial, sans-serif',
          },
          buttonNext: {
            backgroundColor: '#007B8A',
            fontSize: 14,
            padding: '8px 16px',
            borderRadius: 4,
            fontFamily: 'Montserrat, Arial, sans-serif',
          },
          buttonBack: {
            color: '#007B8A',
            fontSize: 14,
            fontFamily: 'Montserrat, Arial, sans-serif',
          },
          buttonSkip: {
            color: '#666',
            fontSize: 14,
            fontFamily: 'Montserrat, Arial, sans-serif',
          },
        }}
        locale={{
          back: 'Précédent',
          close: 'Fermer',
          last: 'Terminer',
          next: 'Suivant',
          skip: 'Passer',
        }}
      />

      {/* Filter Sidebar - Conditionally rendered */}

      {isFilterSidebarOpen && (

        <Box

        sx={{

            width: 240,

            flexShrink: 0,

            bgcolor: 'rgba(249, 250, 251, 0.7)',

            borderRight: '1px solid #E5E7EB',

            transition: 'width 0.2s',

            display: 'flex',

            flexDirection: 'column',

            height: '85vh',

            p: 2

          }}

        >

          {/* Section principale - Navigation */}

          <Box sx={{ mb: 2 }}>

            <Typography variant="h6" sx={{ fontWeight: 600, color: '#1F2937', fontSize: '1.125rem' }}>

              Navigation

            </Typography>

          </Box>



          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, flex: 1 }} data-tourid="sidebar-navigation-filters">

            {sidebarFilters.map((item) => (

              <Box

                key={item.id}

                onClick={() => handleFilterChange(item.id)}

                sx={{

                  display: 'flex',

                  alignItems: 'center',

                  gap: 2,

                  p: 1.5,

                  borderRadius: 2,

                  cursor: 'pointer',

                  bgcolor: activeFilter === item.id ? '#007B8A' : 'transparent',

                  color: activeFilter === item.id ? 'white' : '#6B7280',

                  '&:hover': { bgcolor: activeFilter === item.id ? '#007B8A' : '#F3F4F6', color: activeFilter === item.id ? 'white' : '#374151' },

                  transition: 'all 0.2s ease'

                }}

              >

                <Box sx={{ 

                  color: activeFilter === item.id ? 'white' : '#6B7280',

                  display: 'flex',

                  alignItems: 'center',

                  '& .MuiSvgIcon-root': {

                    fontSize: '20px',

                    width: '20px',

                    height: '20px'

                  }

                }}>

                  {item.icon}

                </Box>

                <Typography sx={{ fontSize: '0.875rem', fontWeight: 500 }}>

                  {item.label}

                </Typography>

              </Box>

            ))}

          </Box>



          {/* Section Statuts - Séparée par une bordure */}

          <Box sx={{ mt: 1, pt: 1, borderTop: '1px solid #E5E7EB' }}>

            <Box sx={{ px: 3, pb: 1 }}>

              <Typography variant="caption" sx={{ 

                fontWeight: 600, 

                textTransform: 'uppercase', 

                color: '#9CA3AF', 

                fontSize: '0.75rem',

                letterSpacing: '0.05em'

              }}>

                Statuts

              </Typography>

            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }} data-tourid="sidebar-status-filters">

              {statusFilters.map((item) => (

                <Box

                  key={item.id}

                  onClick={() => handleFilterChange(item.id)}

                  sx={{

                    display: 'flex',

                    alignItems: 'center',

                    gap: 2,

                    p: 1.5,

                    borderRadius: 2,

                    cursor: 'pointer',

                    bgcolor: activeFilter === item.id ? '#007B8A' : 'transparent',

                    color: activeFilter === item.id ? 'white' : '#6B7280',

                    '&:hover': { bgcolor: activeFilter === item.id ? '#007B8A' : '#F3F4F6', color: activeFilter === item.id ? 'white' : '#374151' },

                    transition: 'all 0.2s ease'

                  }}

                >

                  <Box

                    sx={{

                      width: '10px',

                      height: '10px',

                      borderRadius: '50%',

                      bgcolor: item.color,

                      flexShrink: 0

                    }}

                  />

                  <Typography sx={{ fontSize: '0.875rem', fontWeight: 500 }}>

                    {item.label}

                  </Typography>

                </Box>

              ))}

            </Box>

          </Box>

          </Box>

      )}



      {/* Main Content Area */}

      <Box sx={{ flexGrow: 1, display: 'flex', gap: 3, height: '100%', ml: isFilterSidebarOpen ? 3 : 0, transition: 'margin-left 0.2s' }}>

      {/* Colonne gauche : liste campagnes */}

      <Box sx={{ width: '40%', minWidth: '320px' }}>

        <Paper 

                    sx={{

            p: 2,

            borderRadius: 2,

            boxShadow: 'none',

            bgcolor: 'white',

            height: '100%',

            display: 'flex',

            flexDirection: 'column'

          }}

        >

          <Box display="flex" alignItems="center" pb={1.5} mb={1.5} gap={1.5}>

            <Tooltip title={isFilterSidebarOpen ? "Replier la barre" : "Déplier la barre"} placement="bottom" arrow>

              <IconButton

                data-tourid="filter-sidebar-toggle"

                onClick={() => setIsFilterSidebarOpen(!isFilterSidebarOpen)}

                size="small"

  sx={{

                  color: '#6B7280',

                  border: '1px solid #E5E7EB',

                  borderRadius: '50%',

                  boxShadow: '0 1px 2px rgba(0,0,0,0.05)',

                  '&:hover': { bgcolor: '#F9FAFB' },

                  p: 0.75

                }}

              >

                {isFilterSidebarOpen ? <ChevronLeftIcon sx={{ fontSize: 20 }}/> : <ChevronRightIcon sx={{ fontSize: 20 }}/>}

              </IconButton>

            </Tooltip>

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexGrow: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem', color: '#1F2937' }}>

                Campagnes

              </Typography>
              <Tooltip title="Guide de démarrage">
                <IconButton 
                  size="small" 
                  onClick={() => {
                    // Open sidebar before starting tour to ensure elements are in DOM
                    if (!isFilterSidebarOpen) {
                      setIsFilterSidebarOpen(true);
                      // Wait for sidebar to render before starting tour
                      setTimeout(() => setRunTour(true), 500);
                    } else {
                      setRunTour(true);
                    }
                  }}
                  sx={{ 
                    color: '#007B8A',
                    '&:hover': { backgroundColor: 'rgba(0, 123, 138, 0.08)' },
                    p: 0.5,
                    ml: 1
                  }}
                >
                  <HelpOutlineIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
            </Box>

            <Box display="flex" alignItems="center" gap={1}>

              <Tooltip title="Optimiser campagne existante">

                <IconButton 

                  onClick={() => navigate('/campagne/assistance')}

                  size="small"

                  disabled={GREY_UNDEVELOPED_UI}

  sx={{

                    color: GREY_UNDEVELOPED_UI ? '#9e9e9e' : '#6B7280',

    '&:hover': {

                      color: GREY_UNDEVELOPED_UI ? '#9e9e9e' : '#007B8A',

                      bgcolor: GREY_UNDEVELOPED_UI ? 'transparent' : '#F3F4F6'

                    },

                    p: 0.75

                  }}

                >

                  <AutoFixHighIcon sx={{ fontSize: 20 }} />

                </IconButton>

              </Tooltip>

              <Tooltip title="Nouvelle Campagne">

                <IconButton 

                  data-tourid="new-campaign-button"

                  onClick={handleOpenCreateDialog}

                  size="small"

  sx={{

                    color: '#6B7280',

    '&:hover': {

                      color: '#007B8A',

                      bgcolor: '#F3F4F6'

                    },

                    p: 0.75

                  }}

                >

                  <AddIcon sx={{ fontSize: 20 }} />

                </IconButton>

                      </Tooltip>

              </Box>

                </Box>



          {/* Search & Sort */}

          <Box sx={{ mb: 2 }}>

                <TextField

                  data-tourid="search-campaigns"

                  fullWidth

                  placeholder="Rechercher une campagne..."

                  value={searchInput}

                  onChange={(e) => setSearchInput(e.target.value)}

                  onKeyDown={(e) => {

                    if (e.key === 'Enter') {

                      handleApplySearch();

                    }

                  }}

              size="small"

                  InputProps={{

                    startAdornment: (

                      <InputAdornment position="start">

                    <SearchIcon sx={{ color: '#9CA3AF' }} />

                      </InputAdornment>

                    ),

                    endAdornment: undefined,

                  }}

                />

          </Box>

          {isEmailQuotaReached && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              {emailQuotaMessage}
            </Alert>
          )}

          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }} data-tourid="sort-campaigns">

            <Typography sx={{ mr: 1, fontSize: '0.875rem', color: '#4B5563' }}>Trier par:</Typography>

            <TextField

              select

              size="small"

              value={sortField}

              onChange={(e) => setSortField(e.target.value)}

              sx={{ minWidth: 180, mr: 1 }}

            >

              <MenuItem value="created">Date de création</MenuItem>

              <MenuItem value="modified">Date de modification</MenuItem>

              <MenuItem value="name">Nom</MenuItem>

            </TextField>

            <IconButton

              size="small"

              onClick={() => setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'))}

              sx={{ color: '#6B7280', '&:hover': { color: '#007B8A', bgcolor: '#F3F4F6' } }}

            >

              {sortDirection === 'asc' ? (

                <ArrowUpwardIcon fontSize="small" />

              ) : (

                <ArrowDownwardIcon fontSize="small" />

              )}

            </IconButton>

                    </Box>



          {/* Campagnes List */}

          <Box sx={{ flex: 1, overflow: 'auto' }} data-tourid="campaigns-list">

            <List dense sx={{ p: 0 }}>

              {loading || paginationLoading ? (

                <ListItem>

                  <ListItemText 

                    primary={

                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                        <CircularProgress size={16} />

                        <Typography>

                          {loading ? "Chargement des campagnes..." : "Changement de page..."}

                        </Typography>

                    </Box>

                    } 

                  />

                </ListItem>

              ) : error ? (

                <ListItem>

                  <ListItemText primary={<Typography color="error">{error}</Typography>} />

                </ListItem>

              ) : displayCampaigns.length === 0 ? (

                <ListItem>

                  <ListItemText 
                    primary={
                      activeFilter === 'favorites' ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                          <Typography variant="body2" color="text.secondary">Aucun favori trouvé</Typography>
                          <Button 
                            size="small" 
                            variant="outlined"
                            onClick={() => handleFilterChange('all')}
                            sx={{
                              color: '#007B8A',
                              borderColor: '#007B8A',
                              '&:hover': { backgroundColor: 'rgba(0, 123, 138, 0.08)', borderColor: '#006064' }
                            }}
                          >
                            Parcourir les campagnes
                          </Button>
                        </Box>
                      ) : (
                        'Aucune campagne trouvée sur cette page.'
                      )
                    }
                  />

                </ListItem>

              ) : (

                displayCampaigns.map((campagne) => (

                        <ListItem key={campagne.id} disablePadding>

                          <ListItemButton

                            selected={selected === campagne.id}

                      onClick={() => {

                        setSelected(campagne.id);

                        if (searchParams.has('highlight')) {

                          setSearchParams({}, { replace: true });

                        }

                      }}

                            sx={{

                        borderRadius: 1.5,

                              mb: 0.5,

                        py: 1.25,

                        px: 1.5,

                        bgcolor: selected === campagne.id ? '#E0F2F1' : 'transparent',

                        color: selected === campagne.id ? '#007B8A' : '#4B5563',

                        fontWeight: selected === campagne.id ? 600 : 400,

                        fontSize: '0.875rem',

                              '&:hover': {

                          bgcolor: selected === campagne.id ? '#E0F2F1' : '#F9FAFB',

                        },

                        '& .campaign-actions': {

                          opacity: 0,

                          transition: 'opacity 0.2s',

                        },

                        '&:hover .campaign-actions': {

                          opacity: 1,

                              },

                            }}

                          >

                      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>

                        <IconButton

                          onClick={e => { 

                            e.stopPropagation(); 

                            handleToggleFavorite(campagne.id); 

                          }}

                                size="small"

                          sx={{ p: 0.5 }}

                        >

                          {isFavorite(campagne.id) ? (

                            <StarIcon sx={{ color: '#FFD700', fontSize: 16 }} />

                          ) : (

                            <StarBorderIcon sx={{ color: '#B0B0B0', fontSize: 16 }} />

                          )}

                        </IconButton>

                        

                        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, gap: 1 }}>

                        <Typography 

                                sx={{

                            flex: 1,

                                    overflow: 'hidden',

                                    textOverflow: 'ellipsis',

                                    whiteSpace: 'nowrap',

                              fontSize: '0.875rem',

                              opacity: isArchived(campagne.id) ? 0.6 : 1

                          }}

                        >

                          {campagne.name}

                        </Typography>

                          {isArchived(campagne.id) && (

                            <Chip

                              label="Archivée"

                              size="small"

                              sx={{

                                height: 16,

                                fontSize: '0.625rem',

                                bgcolor: '#F3F4F6',

                                color: '#6B7280',

                                '& .MuiChip-label': {

                                  px: 0.5

                                }

                              }}

                            />

                          )}

                        </Box>



                        <Box className="campaign-actions" sx={{ position: 'absolute', bgcolor: 'white', borderRadius: '5px', right: 80, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 0.5, opacity: 0, transition: 'opacity 0.2s ease-in-out' }}>
                          {/* Bouton Pause/Play selon le statut */}
                          <IconButton
                            onClick={e => {
                              e.stopPropagation();
                              handleToggleActivate(campagne.id);
                            }}
                            size="small"
                            sx={{ p: 0.5, color: campagne.isPublished ? '#059669' : '#B0B0B0', '&:hover': { color: campagne.isPublished ? '#047857' : '#374151' } }}
                            title={campagne.isPublished ? 'Désactiver' : 'Activer'}
                            disabled={updatingCampaignId === campagne.id}
                          >
                            {updatingCampaignId === campagne.id ? (
                              <CircularProgress size={16} />
                            ) : campagne.isPublished ? (
                              <ToggleOnIcon sx={{ fontSize: 16, color: '#059669' }} />
                            ) : (
                              <ToggleOffIcon sx={{ fontSize: 16, color: '#9CA3AF' }} />
                            )}
                          </IconButton>
                          {/* Bouton Modifier */}
                          <IconButton
                            onClick={e => {
                              e.stopPropagation();
                              setEditCampaignId(campagne.id);
                              setEditIsLoading(true);
                              setEditHasError(false);
                              setEditDialogOpen(true);
                            }}
                            size="small"
                            sx={{ p: 0.5, color: '#4B5563', '&:hover': { color: '#007B8A' } }}
                            title="Modifier"
                          >
                            <EditIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                          {/* Bouton Cloner (masqué temporairement)
                          <IconButton
                            onClick={e => {
                              e.stopPropagation();
                              openDuplicateDialog(campagne.id);
                            }}
                            size="small"
                            sx={{ p: 0.5, color: '#B0B0B0', '&:hover': { color: '#007B8A' } }}
                            title="Cloner"
                          >
                            <ContentCopyIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                          */}
                          {/* Bouton Archiver/Restaurer */}
                          <IconButton
                            onClick={e => {
                              e.stopPropagation();
                              if (isArchived(campagne.id)) {
                                handleRestoreCampaign(campagne.id);
                              } else {
                                handleArchiveCampaign(campagne.id);
                              }
                            }}
                            size="small"
                            sx={{ p: 0.5, color: '#B0B0B0', '&:hover': { color: isArchived(campagne.id) ? '#10B981' : '#F59E0B' } }}
                            title={isArchived(campagne.id) ? 'Restaurer' : 'Archiver'}
                          >
                            {isArchived(campagne.id) ? (
                              <UnarchiveIcon sx={{ fontSize: 16 }} />
                            ) : (
                              <ArchiveIcon sx={{ fontSize: 16 }} />
                            )}
                          </IconButton>
                          {/* Bouton Supprimer */}
                          <IconButton
                            onClick={e => {
                              e.stopPropagation();
                              setSelectedCampaignId(campagne.id);
                              setDeleteDialogOpen(true);
                            }}
                            size="small"
                            sx={{ p: 0.5, color: '#B0B0B0', '&:hover': { color: '#EF4444' } }}
                            title="Supprimer"
                          >
                            <DeleteIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Box>

                        

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                          <Box

                          sx={{

                              width: '10px',

                              height: '10px',

                              borderRadius: '50%',

                            bgcolor: getCampagneStatus(campagne).color,

                              flexShrink: 0

                            }}

                          />

                        </Box>

                      </Box>

                          </ListItemButton>

                        </ListItem>

                ))

                  )}

            </List>

            </Box>



          {/* Pagination */}

          {!loading && (

            <Box data-tourid="pagination" sx={{ 

               pt: 2, 

               display: 'flex',

               flexDirection: 'column',

               gap: 1

             }}>

               

               <Box sx={{ 

               display: 'flex',

               alignItems: 'center',

               justifyContent: 'center',

               position: 'relative'

             }}>

               {/* Items per page selector */}

               <TextField

                 select

                 size="small"

                 value={pageSize}

                 onChange={handlePageSizeChange}

                 sx={{ mr: 2, width: 72 }}

               >

                 {PAGE_SIZE_OPTIONS.map((n) => (

                   <MenuItem key={n} value={n}>{n}</MenuItem>

                 ))}

               </TextField>

               <Pagination

                count={totalPages}

                page={currentPage}

                onChange={handlePageChange}

                disabled={paginationLoading}

                color="primary"

                size="small"

                sx={{

                  '& .MuiPaginationItem-root': {

                    color: '#6B7280',

                    '&:hover': {

                      bgcolor: '#F3F4F6',

                    },

                    '&.Mui-selected': {

                      bgcolor: '#007B8A',

                      color: 'white',

                      '&:hover': {

                        bgcolor: '#006064',

                      },

                    },

                  },

                }}

               />

               <Typography sx={{ position: 'absolute', right: 0, fontSize: '0.75rem', color: '#4B5563', fontWeight: 500 }}>

                 {totalCampaigns}

                    </Typography>

                    </Box>

                  </Box>

          )}

                </Paper>

      </Box>



      {/* Colonne droite : détails campagne */}

      <Box sx={{ width: '60%' }} data-tourid="campaign-details">

        {selected ? (

          <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 2, height: '100%', overflowY: 'auto' }}>

                  <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1} mb={2}>

                    <Box>

                    <Typography variant="h6" color="#1976d2" fontWeight={700} fontFamily="Montserrat, Arial, sans-serif">

                      {findCampaignById(selected)?.name || "Campagne"}

                    </Typography>

                      {/* Affichage du statut avec point coloré */}

                      {(() => {

                        const campagne = findCampaignById(selected);

                        if (!campagne) return null;

                        const statut = getCampagneStatus(campagne);

                        return (

                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>

                            <Box

                              sx={{

                                width: '10px',

                                height: '10px',

                                borderRadius: '50%',

                                bgcolor: statut.color,

                                flexShrink: 0

                              }}

                            />

                            <Typography

                              variant="caption"

                              sx={{

                                color: statut.color,

                                fontWeight: 600,

                                fontSize: '0.75rem',

                                bgcolor: `${statut.color}15`,

                                px: 1.5,

                                py: 0.5,

                                borderRadius: '12px',

                                border: `1px solid ${statut.color}30`

                              }}

                            >

                              {statut.label}

                            </Typography>

                          </Box>

                        );

                      })()}

                    </Box>

                    <Stack direction="row" spacing={1} alignItems="center">

                      <Tooltip title={iaAnalysisLoading || !iaAnalysis ? "Veuillez attendre la fin de l'analyse IA pour optimiser" : "Lancer l'assistant d'optimisation"}>

                        <span>

                          <Button
                           
                            variant="contained"

                            color="warning"

                            size="small"

                            startIcon={<RocketLaunchIcon />}

                            disabled={GREY_UNDEVELOPED_UI || iaAnalysisLoading || !iaAnalysis}

                            onClick={() => {

                              const camp = findCampaignById(selected);

                              if (camp) {

                                navigate(`/campagne/assistance?campaignId=${camp.id}&campaignName=${encodeURIComponent(camp.name)}`);

                              }

                            }}

                            sx={{

                              bgcolor: GREY_UNDEVELOPED_UI ? '#F3F4F6' : '#FEF3C7',

                              color: GREY_UNDEVELOPED_UI ? '#9CA3AF' : '#92400E',

                              border: GREY_UNDEVELOPED_UI ? '1px solid #E5E7EB' : '1px solid #F59E0B',

                              '&:hover': {

                                bgcolor: GREY_UNDEVELOPED_UI ? '#F3F4F6' : '#FDE68A'

                              }

                            }}

                          >

                            Optimiser

                          </Button>

                        </span>

                      </Tooltip>

                      

                      {/* Menu d'actions "..." */}

                      <Box sx={{ position: 'relative' }}>

                        <IconButton

                          onClick={handleActionMenuOpen}

                          sx={{

                            color: '#6B7280',

                            '&:hover': { bgcolor: '#F3F4F6' }

                          }}

                        >

                          <MoreVertIcon />

                        </IconButton>

                        <Menu

                          anchorEl={actionMenuAnchor}

                          open={actionMenuOpen}

                          onClose={handleActionMenuClose}

                          anchorOrigin={{

                            vertical: 'bottom',

                            horizontal: 'right',

                          }}

                          transformOrigin={{

                            vertical: 'top',

                            horizontal: 'right',

                          }}

                          PaperProps={{

                            sx: {

                              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',

                              border: '1px solid #E5E7EB',

                              borderRadius: 2,

                              minWidth: 180

                            }

                          }}

                        >

                          {!HIDE_INCOMPLETE_FEATURES && (
                            <MenuItem onClick={() => openDuplicateDialog(selected)}>
                              <ListItemIcon>
                                <ContentCopyIcon fontSize="small" />
                              </ListItemIcon>
                              Dupliquer
                            </MenuItem>
                          )}

                          <MenuItem onClick={() => {

                            if (isArchived(selected)) {

                              handleRestoreCampaign(selected);

                            } else {

                              handleArchiveCampaign(selected);

                            }

                            handleMenuClose();

                          }}>

                            <ListItemIcon>

                              {isArchived(selected) ? (

                                <UnarchiveIcon fontSize="small" />

                              ) : (

                              <ArchiveIcon fontSize="small" />

                              )}

                            </ListItemIcon>

                            {isArchived(selected) ? 'Restaurer' : 'Archiver'}

                          </MenuItem>

                          <MenuItem
                            onClick={() => {
                              const camp = findCampaignById(selected);
                              if (camp) {
                                setEditCampaignId(camp.id);
                                setEditIsLoading(true);
                                setEditHasError(false);
                                setEditDialogOpen(true);
                              }
                              handleActionMenuClose();
                            }}
                          >
                            <ListItemIcon>
                              <EditIcon fontSize="small" />
                            </ListItemIcon>
                            Modifier
                          </MenuItem>

                          <MenuItem onClick={() => {

                            setSelectedCampaignId(selected);

                            setDeleteDialogOpen(true);

                          }} sx={{ color: 'error.main' }}>

                            <ListItemIcon>

                              <DeleteIcon fontSize="small" color="error" />

                            </ListItemIcon>

                            Supprimer

                          </MenuItem>

                        </Menu>

                      </Box>

                    </Stack>

                  </Box>



            {/* Tabs */}

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>

              <Tabs 

                value={tabValue} 

                onChange={handleTabChange}

                sx={{

                  '& .MuiTab-root': {

                    textTransform: 'none',

                    fontSize: '0.875rem',

                    fontWeight: 500,

                    color: '#6B7280',

                    '&.Mui-selected': {

                      color: '#007B8A',

                      fontWeight: 600,

                    },

                  },

                  '& .MuiTabs-indicator': {

                    backgroundColor: '#007B8A',

                  },

                }}

              >

                <Tab label="Analyse et recommandations" />

                <Tab label="Performances" />

                <Tab label="Configuration" />

                <Tab label="Calendrier" />

                <Tab label="Workflow" />

              </Tabs>

            </Box>



            {/* Tab Content */}

            {tabValue === 0 && (

              <Box sx={{ py: 2 }}>

                  {/* Section d'analyse IA */}

                  <Box bgcolor="#e3f0fe" borderRadius={2} p={2} mb={2}>

  <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>

    <Typography fontWeight={700} color="#1976d2" fontFamily="Montserrat, Arial, sans-serif">

      ANALYSE PAR IA

    </Typography>

    <Stack direction="row" spacing={1} alignItems="center">
      <Tooltip title="Actualiser l'analyse" placement="top" arrow>
        <span>
          <IconButton
            onClick={handleRefreshIaAnalysis}
            disabled={iaAnalysisLoading || !selected}
            size="small"
            sx={{
              color: (iaAnalysisLoading || !selected) ? '#D1D5DB' : '#6B7280',
              border: '1px solid',
              borderColor: (iaAnalysisLoading || !selected) ? '#E5E7EB' : '#D1D5DB',
              bgcolor: 'transparent',
              '&:hover': {
                bgcolor: (iaAnalysisLoading || !selected) ? 'transparent' : '#F3F4F6',
                color: (iaAnalysisLoading || !selected) ? '#D1D5DB' : '#007B8A'
              },
              '&:disabled': {
                bgcolor: 'transparent',
                borderColor: '#E5E7EB',
                color: '#D1D5DB'
              },
              transition: 'all 0.2s ease-in-out'
            }}
          >
            <RefreshIcon 
              sx={{ 
                fontSize: 16,
                transform: iaAnalysisLoading ? 'rotate(360deg)' : 'none',
                transition: iaAnalysisLoading ? 'transform 1s linear infinite' : 'transform 0.2s ease-in-out'
              }} 
            />
          </IconButton>
        </span>
      </Tooltip>

      <Button
      variant="outlined"
      size="small"
      onClick={() => setIsExpanded(!isExpanded)}
      sx={{
        color: '#1976d2',
        borderColor: '#1976d2',
        '&:hover': {
          backgroundColor: 'rgba(25, 118, 210, 0.08)',
          borderColor: '#1976d2'
        }
      }}
    >
      {isExpanded ? (<><ExpandLessIcon sx={{ mr: 1 }} /> Réduire</>) : (<><ExpandMoreIcon sx={{ mr: 1 }} /> Déplier</>)}
    </Button>
    </Stack>

  </Stack>



  {iaAnalysisLoading ? (

    <Box display="flex" alignItems="center" justifyContent="center">

      <CircularProgress size={20} />

    </Box>

  ) : iaAnalysisError ? (

    <Typography color="error" fontSize={15}>{iaAnalysisError}</Typography>

  ) : iaAnalysis ? (

    <Collapse in={isExpanded} collapsedSize={150}>

      {[

        { label: "Évaluation Globale", content: iaAnalysis.evaluation },

        { label: "Indicateurs clés", content: iaAnalysis.indicateurs },

        { label: "Comparaison aux benchmarks du secteur", content: iaAnalysis.benchmarks },

        { label: "Aperçu des performances des e-mails individuels", content: iaAnalysis.apercu },

        { label: "Points forts et points faibles", content: iaAnalysis.pointsSection }

      ].map((section, index) => (

        <Box key={index} mt={2}>

          <Typography fontWeight={700} color="#495057" fontFamily="Montserrat, Arial, sans-serif">

            {section.label}

          </Typography>

          {section.label.includes('Aperçu des performances') && iaAnalysis.statistics ? (

            (() => {

              const stats = iaAnalysis.statistics;

              const emailStats = stats.email_statistics?.per_email_stats || {};

              const clickStats = stats.click_statistics?.per_email_clicks || {};



              const emailData = Object.keys(emailStats).map(emailId => {

                const email = emailStats[emailId];

                const clicks = clickStats[emailId];

                const sent = email.total_sent || 0;



                const openRate = sent > 0 ? ((email.unique_opens / sent) * 100).toFixed(2) + '%' : '0.00%';

                const clickRate = sent > 0 && clicks ? ((clicks.total_clicks / sent) * 100).toFixed(2) + '%' : '0.00%';

                const unsubscribeRate = sent > 0 ? ((email.total_unsubscribes / sent) * 100).toFixed(2) + '%' : '0.00%';



                return {

                  id: emailId,

                  name: email.email_name || `Email ID: ${emailId}`,

                  openRate,

                  clickRate,

                  unsubscribeRate

                };

              });



              if (emailData.length === 0) {

                return <Typography sx={{ mt: 1, fontStyle: 'italic' }}>Aucune statistique détaillée par email disponible.</Typography>;

              }



              return (

                <TableContainer component={Paper} sx={{ mt: 1, border: '1px solid rgba(224, 224, 224, 1)', borderRadius: 2 }}>

                  <Table size="small" sx={{ '& .MuiTableCell-root': { borderBottom: '1px solid rgba(224, 224, 224, 1)' } }}>

                    <TableHead>

                      <TableRow>

                        <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Email</TableCell>

                        <TableCell align="right" sx={{ fontWeight: 'bold', color: 'primary.main' }}>Taux d'ouverture (unique)</TableCell>

                        <TableCell align="right" sx={{ fontWeight: 'bold', color: 'primary.main' }}>Taux de clics</TableCell>

                        <TableCell align="right" sx={{ fontWeight: 'bold', color: 'primary.main' }}>Taux de désabonnement</TableCell>

                      </TableRow>

                    </TableHead>

                    <TableBody>

                      {emailData.map((row) => (

                        <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                          <TableCell>{row.name}</TableCell>

                          <TableCell align="right">{row.openRate}</TableCell>

                          <TableCell align="right">{row.clickRate}</TableCell>

                          <TableCell align="right">{row.unsubscribeRate}</TableCell>

                        </TableRow>

                      ))}

                    </TableBody>

                  </Table>

                </TableContainer>

              );

            })()

          ) : section.label.includes('Aperçu des performances') ? (

             <Typography sx={{ mt: 1, fontStyle: 'italic' }}>{section.content || 'Analyse textuelle non disponible.'}</Typography>

          ) : (

            <Typography

              color="#495057"

              sx={{

                textAlign: 'justify',

                whiteSpace: 'pre-line',

                lineHeight: 1.7

              }}

            >

              {section.content

                ?.replace(/(?<!\n)- /g, '\n- ') // 

                .split(/(?<=\.)\s+(?=[A-Z•])/) 

                .map((line, idx) => (

                  <React.Fragment key={idx}>

                    {line.trim()}

                    {idx < section.content.length - 1 && <br />}

                  </React.Fragment>

                )) || 'Non disponible'}

            </Typography>

          )}

        </Box>

      ))}

    </Collapse>

  ) : (

    <Typography fontSize={15} color="#495057">Aucune analyse disponible pour cette campagne</Typography>

  )}

</Box>



                    {/* Section de suggestions IA */}

                    <Box bgcolor="#f5f5f5" borderRadius={2} p={2} mt={2}>

                      <Typography fontWeight={700} color="#1976d2" mb={1} fontFamily="Montserrat, Arial, sans-serif">

                        SUGGESTIONS IA

                      </Typography>

                      {iaAnalysisLoading ? (

                        <Box display="flex" alignItems="center" justifyContent="center">

                          <CircularProgress size={20} />

                        </Box>

                      ) : iaAnalysisError ? (

                        <Typography color="error" fontSize={15}>

                          {iaAnalysisError}

                        </Typography>

                      ) : iaAnalysis ? (

                        <>

                          <Typography fontWeight={700} color="#495057" fontFamily="Montserrat, Arial, sans-serif" mt={2}>Recommandations</Typography>

                          <Typography

  color="#495057"

  sx={{

    textAlign: 'justify',

    whiteSpace: 'pre-line',

    lineHeight: 1.7

  }}

>

  {iaAnalysis?.recommandations

    ?.replace(/(?<!\n)- /g, '\n- ') // 

    .split(/\n+/)

    .map((line, idx) => (

      <React.Fragment key={idx}>

        {line.trim()}

        {idx < iaAnalysis.recommandations.length - 1 && <br />}

        {idx < iaAnalysis.recommandations.length - 1 && <br />}

      </React.Fragment>

    )) || 'Non disponible'}

</Typography>

                        </>

                      ) : (

                        <Typography fontSize={15} color="#495057">

                          Aucune analyse disponible pour cette campagne

                        </Typography>

                      )}

                    </Box>

              </Box>

            )}



            {tabValue === 1 && (

              <Box sx={{ py: 2 }}>

                {/* Carte des KPIs Généraux */}

                <Box sx={{ p: 3, mb: 3, border: '1px solid #E5E7EB', borderRadius: 2, bgcolor: 'white' }}>

                  {(() => {

                    // Extraire les métriques depuis l'analyse IA

                    let totalEmailsSent = 0;

                    let totalOpens = 0;

                    let totalClicks = 0;

                    let totalConversions = 0;

                    let openRate = '0.00%';

                    let clickRate = '0.00%';

                    let conversionRate = '0.00%';

                    // Afficher un état de chargement tant que l'analyse est en cours,
                    // pour éviter d'afficher des zéros temporaires.
                    if (iaAnalysisLoading) {
                      return (
                        <>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                            <TrendingUpIcon sx={{ color: '#9CA3AF' }} />
                            <Typography variant="h6" fontWeight={600}>Métriques de Performance</Typography>
                          </Box>
                          <Box sx={{ py: 2, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                            <CircularProgress size={18} />
                            <Typography variant="body2" color="text.secondary">Chargement des statistiques globales...</Typography>
                          </Box>
                        </>
                      );
                    }

                    if (iaAnalysis?.statistics) {

                      const stats = iaAnalysis.statistics;

                      const emailStats = stats.email_statistics || {};

                      const clickStats = stats.click_statistics || {};



                      // Calculer les totaux

                      totalEmailsSent = emailStats.total_sent || 0;

                      totalOpens = emailStats.emails_read || 0;

                      totalClicks = clickStats.total_clicks || 0;

                      

                      // Calculer les taux

                      if (totalEmailsSent > 0) {

                        openRate = ((totalOpens / totalEmailsSent) * 100).toFixed(2) + '%';

                        clickRate = ((totalClicks / totalEmailsSent) * 100).toFixed(2) + '%';

                      }



                      // Pour les conversions, on peut utiliser les clics uniques comme approximation

                      // ou chercher dans d'autres métriques disponibles

                      totalConversions = clickStats.campaign_pairs_with_clicks || totalClicks;

                      if (totalEmailsSent > 0) {

                        conversionRate = ((totalConversions / totalEmailsSent) * 100).toFixed(2) + '%';

                      }

                    }



                    return (

                      <>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>

                          <TrendingUpIcon sx={{ color: '#9CA3AF' }} />

                          <Typography variant="h6" fontWeight={600}>Métriques de Performance</Typography>

                        </Box>

                  <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 2, textAlign: 'center' }}>

                    <Box>

                      <Typography variant="caption" color="text.secondary">Emails Envoyés</Typography>

                            <Typography variant="h5" fontWeight="bold" color="text.primary">

                              {totalEmailsSent.toLocaleString()}

                            </Typography>

                    </Box>

                    <Box>

                      <Typography variant="caption" color="text.secondary">Taux d'Ouverture</Typography>

                            <Typography variant="h5" fontWeight="bold" color="text.primary">{openRate}</Typography>

                    </Box>

                    <Box>

                      <Typography variant="caption" color="text.secondary">Taux de Clics</Typography>

                            <Typography variant="h5" fontWeight="bold" color="text.primary">{clickRate}</Typography>

                    </Box>

                    <Box>

                      <Typography variant="caption" color="text.secondary">Conversions</Typography>

                            <Typography variant="h5" fontWeight="bold" color="text.primary">

                              {totalConversions.toLocaleString()}

                            </Typography>

                    </Box>

                  </Box>

                      </>

                    );

                  })()}

                </Box>



                {/* Message si aucune analyse IA n'est disponible */}

                {!iaAnalysis?.statistics && (

                  <Box sx={{ p: 3, mb: 3, border: '1px solid #E5E7EB', borderRadius: 2, bgcolor: '#F9FAFB' }}>

                    <Box sx={{ textAlign: 'center', py: 2 }}>

                      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>

                        Aucune analyse IA disponible

                      </Typography>

                      <Typography variant="caption" color="text.secondary">

                        Les métriques de performance s'afficheront ici une fois l'analyse IA effectuée

                      </Typography>

                    </Box>

                  </Box>

                )}



                {/* Carte de Performance des Emails */}

                <Box sx={{ p: 3, mb: 3, border: '1px solid #E5E7EB', borderRadius: 2, bgcolor: 'white' }}>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>

                    <EmailIcon sx={{ color: '#9CA3AF' }} />

                    <Typography variant="h6" fontWeight={600}>Performance des Emails</Typography>

                  </Box>

                  <Box sx={{ borderTop: '1px solid #F3F4F6' }}>

                    {(() => {
                      // Afficher le chargement pendant le calcul IA pour éviter tout rendu partiel
                      if (iaAnalysisLoading) {
                        return (
                          <Box sx={{ py: 2, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                            <CircularProgress size={18} />
                            <Typography variant="body2" color="text.secondary">Chargement des statistiques e-mails...</Typography>
                          </Box>
                        );
                      }

                      // Afficher l'erreur si l'analyse a échoué
                      if (iaAnalysisError) {
                        return (
                          <Box sx={{ py: 2, textAlign: 'center' }}>
                            <Typography variant="body2" color="error">{iaAnalysisError}</Typography>
                          </Box>
                        );
                      }

                      // Rendre les statistiques si disponibles
                      if (iaAnalysis?.statistics) {
                        const campagne = findCampaignById(selected);
                        const collectEmailEvents = (events) => {
                          let result = [];
                          if (!Array.isArray(events)) return result;
                          for (const ev of events) {
                            if (ev?.type === 'email.send' && ev?.properties?.email) {
                              result.push(ev);
                            }
                            if (Array.isArray(ev?.children)) {
                              result = result.concat(collectEmailEvents(ev.children));
                            }
                          }
                          return result;
                        };

                        const emailEvents = collectEmailEvents(campagne?.events);
                        const targetedIds = Array.from(new Set(emailEvents.map(ev => String(ev?.properties?.email)).filter(Boolean)));

                        const stats = iaAnalysis.statistics;
                        const emailStats = stats.email_statistics?.per_email_stats || {};
                        const clickStats = stats.click_statistics?.per_email_clicks || {};

                        const idsToRender = (targetedIds && targetedIds.length > 0)
                          ? targetedIds
                          : Object.keys(emailStats);

                        if (!idsToRender || idsToRender.length === 0) {
                          return (
                            <Box sx={{ py: 2, textAlign: 'center' }}>
                              <Typography variant="body2" color="text.secondary">Aucune statistique disponible</Typography>
                            </Box>
                          );
                        }

                        const rows = idsToRender.map((emailId) => {
                          const es = emailStats[emailId] || {};
                          const cs = clickStats[emailId] || {};
                          const sent = Number(es.total_sent || 0);
                          const uniqueOpens = Number(es.unique_opens || 0);
                          const totalClicks = Number(cs.total_clicks || 0);
                          const unsub = Number(es.total_unsubscribes || 0);
                          const openRate = sent > 0 ? ((uniqueOpens / sent) * 100).toFixed(2) + '%' : '0.00%';
                          const clickRate = sent > 0 ? ((totalClicks / sent) * 100).toFixed(2) + '%' : '0.00%';
                          const unsubRate = sent > 0 ? ((unsub / sent) * 100).toFixed(2) + '%' : '0.00%';
                          const name =
                            es.email_name
                            || emailNamesById[String(emailId)]?.name
                            || (emails.find(e => String(e.id) === String(emailId))?.name)
                            || `ID: ${emailId}`;
                          return { id: emailId, name, sent, uniqueOpens, totalClicks, unsub, openRate, clickRate, unsubRate };
                        });

                        return rows.map((row, index) => (
                          <Box key={row.id || index} sx={{ py: 2, borderBottom: index < rows.length - 1 ? '1px solid #F3F4F6' : 'none' }}>
                            <Tooltip title={`Voir l'aperçu de l'email "${row.name}"`}>
                              <Chip
                                label={row.name}
                                size="small"
                                sx={{ bgcolor: '#F3E8FF', color: '#7C3AED', mb: 1, '&:hover': { bgcolor: '#E9D5FF' } }}
                              />
                            </Tooltip>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.75rem' }}>
                              <Typography variant="caption" color="text.secondary">
                                Envoyés: <Box component="span" fontWeight={600} color="text.primary">{row.sent.toLocaleString()}</Box>
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Ouv: <Box component="span" fontWeight={600} color="text.primary">{row.uniqueOpens.toLocaleString()} ({row.openRate})</Box>
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Clics: <Box component="span" fontWeight={600} color="text.primary">{row.totalClicks.toLocaleString()} ({row.clickRate})</Box>
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Désabonnements: <Box component="span" fontWeight={600} color="text.primary">{row.unsub.toLocaleString()} ({row.unsubRate})</Box>
                              </Typography>
                            </Box>
                          </Box>
                        ));
                      }

                      // Sinon, aucune statistique disponible
                      return (
                        <Box sx={{ py: 2, textAlign: 'center' }}>
                          <Typography variant="body2" color="text.secondary">Aucune statistique disponible</Typography>
                        </Box>
                      );

                    })()}

                  </Box>

                </Box>



                {/* Carte de Performance des Segments */}

                <Box sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2, bgcolor: 'white' }}>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>

                    <SegmentIcon sx={{ color: '#9CA3AF' }} />

                    <Typography variant="h6" fontWeight={600}>Performance des Segments</Typography>

                  </Box>

                  <Box sx={{ borderTop: '1px solid #F3F4F6' }}>

                    {(() => {

                      const campagne = findCampaignById(selected);

                      if (!campagne || !Array.isArray(campagne.lists) || campagne.lists.length === 0) {

                        return (

                          <Box sx={{ py: 2, textAlign: 'center' }}>

                            <Typography variant="body2" color="text.secondary">Aucun segment ciblé</Typography>

                          </Box>

                        );

                      }



                      return campagne.lists.map((list, index) => (

                        <Box key={list.id} sx={{ py: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: index < campagne.lists.length - 1 ? '1px solid #F3F4F6' : 'none' }}>

                          <Tooltip title={`Voir le segment "${list.name}"`}>

                            <Chip

                              label={list.name || `ID: ${list.id}`}

                              size="small"

                              sx={{

                                bgcolor: '#DBEAFE',

                                color: '#1D4ED8',

                                '&:hover': { bgcolor: '#BFDBFE' }

                              }}

                              clickable

                              onClick={() => navigate('/segment', { 
                                state: { 
                                  searchTerm: list.name,
                                  source: 'campaign' 
                                } 
                              })}

                            />

                          </Tooltip>

                          <Typography variant="body2" fontSize="0.875rem">
                            {(() => {
                              const rawKey = list?.name || list?.id;
                              const key = normalizeKey(rawKey);
                              const isLoading = segmentCountsLoading[key];
                              const count = segmentCounts[key];
                              const display = typeof count === 'number' ? count : null;
                              return (
                                <>
                                  Taille: {isLoading || display === null ? (
                                    <Box component="span" sx={{ ml: 1, display: 'inline-flex', verticalAlign: 'middle' }}>
                                      <CircularProgress size={14} thickness={5} />
                                    </Box>
                                  ) : (
                                    <Box component="span" fontWeight={600} color="text.primary">{display}</Box>
                                  )}
                                </>
                              );
                            })()}
                          </Typography>

                        </Box>

                      ));

                    })()}

                  </Box>

                </Box>

              </Box>

            )}






            {tabValue === 4 && (

              <Box sx={{ py: 2 }}>

                {(() => {
                  const campagne = findCampaignById(selected);
                  const id = campagne?.id;
                  const base = API_BASE_URL || window.location.origin;
                  const src = id ? `${base}/campaigns/mautic/proxy?path=/s/campaigns/view/${encodeURIComponent(id)}` : null;
                  if (!src) {
                    return (
                      <Box sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2, bgcolor: '#F9FAFB' }}>
                        <Typography variant="body2" color="text.secondary">Aucune campagne sélectionnée</Typography>
                      </Box>
                    );
                  }
                  return (
                    <Box sx={{ border: '1px solid #E5E7EB', borderRadius: 2, bgcolor: 'white', height: '70vh', overflow: 'hidden', position: 'relative' }}>
                      {workflowLoading && (
                        <Box sx={{ 
                          position: 'absolute', 
                          top: 0, 
                          left: 0, 
                          right: 0, 
                          bottom: 0, 
                          display: 'flex', 
                          flexDirection: 'column',
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          bgcolor: 'rgba(255, 255, 255, 0.9)',
                          zIndex: 1
                        }}>
                          <CircularProgress size={40} sx={{ mb: 2 }} />
                          <Typography variant="body2" color="text.secondary">
                            Chargement du workflow...
                          </Typography>
                        </Box>
                      )}
                      <iframe
                        title="Mautic Workflow"
                        src={src}
                        style={{ border: 'none', width: '100%', height: '100%' }}
                        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
                        onLoad={() => setWorkflowLoading(false)}
                        onError={() => setWorkflowLoading(false)}
                      />
                    </Box>
                  );
                })()}

              </Box>

            )}

            {tabValue === 3 && (

              <Box sx={{ py: 2 }}>

                <Box sx={{ p: 3, border: '1px solid #E5E7EB', borderRadius: 2, bgcolor: 'white' }}>

                  <Box sx={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 4 }}>

                    {/* Colonne Calendrier - similaire au template */}
                    <Box>
                      {/* Header: navigation + view toggle */}
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <IconButton size="small" sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F4F6' } }} onClick={() => { const d = new Date(selectedDate); d.setMonth(d.getMonth() - 1); setSelectedDate(d); }}>
                            <ChevronLeftIcon />
                          </IconButton>
                          <Typography variant="h6" fontWeight={600} color="text.primary">
                            {selectedDate.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
                          </Typography>
                          <IconButton size="small" sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F4F6' } }} onClick={() => { const d = new Date(selectedDate); d.setMonth(d.getMonth() + 1); setSelectedDate(d); }}>
                            <ChevronRightIcon />
                          </IconButton>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1, border: '1px solid #E5E7EB', borderRadius: 2, p: 0.5 }}>
                          <Button size="small" variant={campaignCalView === 'sequence' ? 'contained' : 'text'} onClick={() => setCampaignCalView('sequence')} sx={{ boxShadow: 'none' }}>Séquence</Button>
                          <Button size="small" variant={campaignCalView === 'month' ? 'contained' : 'text'} onClick={() => setCampaignCalView('month')} sx={{ boxShadow: 'none' }}>Mois</Button>
                        </Box>
                      </Box>

                      {campaignCalView === 'sequence' ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          {campaignSchedules.length === 0 ? (
                            <Typography variant="body2" color="text.secondary">Aucune séquence programmée</Typography>
                          ) : (
                            campaignSchedules.map((s, idx) => {
                              const em = campaignEmails.find(e => String(e.id) === String(s.emailId));
                              if (isMeaninglessEmailName(em?.name)) return null;
                              return (
                                <Box key={idx} sx={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #E5E7EB' }}>
                                  <Box sx={{ width: 140, textAlign: 'center', py: 1, bgcolor: '#F9FAFB', fontSize: '0.75rem', flexShrink: 0 }}>
                                    {s.triggerMode === 'date' && s.triggerDate ? new Date(s.triggerDate).toLocaleString('fr-FR') : s.triggerMode === 'interval' && s.triggerInterval ? `${s.triggerInterval} ${s.triggerIntervalUnit || ''} après` : 'Non daté'}
                                  </Box>
                                  <Box sx={{ p: 1 }}>
                                    <Box sx={{ fontSize: '0.75rem', bgcolor: '#F3E8FF', color: '#7C3AED', borderRadius: 1, display: 'inline-block', px: 1, py: 0.5, fontWeight: 600 }}>
                                      {em?.name || `Email ${s.emailId}`}
                                    </Box>
                                  </Box>
                                </Box>
                              );
                            })
                          )}
                        </Box>
                      ) : (
                        <>
                          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', textAlign: 'center', mb: 1 }}>
                            {['DI', 'LU', 'MA', 'ME', 'JE', 'VE', 'SA'].map((day) => (
                              <Typography key={day} variant="caption" color="text.secondary" sx={{ py: 0.5 }}>{day}</Typography>
                            ))}
                          </Box>
                          {(() => {
                            const y = selectedDate.getFullYear();
                            const m = selectedDate.getMonth();
                            const firstOfMonth = new Date(y, m, 1);
                            const start = new Date(firstOfMonth);
                            start.setDate(firstOfMonth.getDate() - firstOfMonth.getDay()); // start Sunday
                            const days = Array.from({ length: 42 }, (_, i) => { const d = new Date(start); d.setDate(start.getDate() + i); return d; });
                            const byDay = {};
                            campaignSchedules.forEach(s => {
                              if (s.triggerMode === 'date' && s.triggerDate) {
                                const dt = new Date(s.triggerDate);
                                const key = formatYMD(dt);
                                if (!byDay[key]) byDay[key] = [];
                                const em = campaignEmails.find(e => String(e.id) === String(s.emailId));
                                const nm = em?.name || `Email ${s.emailId}`;
                                if (!isMeaninglessEmailName(nm)) {
                                  byDay[key].push({ name: nm, color: '#8B5CF6' });
                                }
                              }
                            });
                            return (
                              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 0.5 }}>
                                {days.map((d, idx) => {
                                  const isCurrentMonth = d.getMonth() === m;
                                  const isToday = formatYMD(d) === formatYMD(new Date());
                                  const key = formatYMD(d);
                                  const items = byDay[key] || [];
                                  return (
                                    <Box key={idx} sx={{ p: 0.75, minHeight: 82, border: '1px solid #F3F4F6', borderRadius: 1, bgcolor: 'white' }}>
                                      <Typography variant="caption" sx={{ fontWeight: isToday ? 700 : 400, color: isCurrentMonth ? '#111827' : '#9CA3AF' }}>
                                        {d.getDate()}
                                      </Typography>
                                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 0.5 }}>
                                        {items.map((it, i2) => (
                                          <Box key={i2} sx={{ fontSize: '0.7rem', bgcolor: it.color, color: 'white', px: 0.75, py: 0.25, borderRadius: 1, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {it.name}
                                          </Box>
                                        ))}
                                      </Box>
                                    </Box>
                                  );
                                })}
                              </Box>
                            );
                          })()}
                        </>
                      )}
                    </Box>

                    

                    {/* Colonne Légende - Emails réels de la campagne */}
                    <Box sx={{ borderLeft: '1px solid #E5E7EB', pl: 3 }}>
                      <Typography variant="h6" fontWeight={600} color="text.primary" mb={2}>
                        Planification des Emails
                      </Typography>
                      {campaignEmailsLoading ? (
                        <Box sx={{ py: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CircularProgress size={18} />
                          <Typography variant="body2" color="text.secondary">Chargement des emails…</Typography>
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          {campaignEmails.length === 0 ? (
                            <Typography variant="body2" color="text.secondary">Aucun email trouvé pour cette campagne</Typography>
                          ) : (
                            campaignEmails.map((em) => {
                              if (isMeaninglessEmailName(em?.name)) return null;
                              const scheds = campaignSchedules.filter(s => String(s.emailId) === String(em.id));
                              return (
                                <Box key={em.id} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                                  <Box
                                    sx={{
                                      width: '10px',
                                      height: '10px',
                                      borderRadius: '50%',
                                      bgcolor: em.isPublished ? '#10B981' : '#F59E0B',
                                      mt: 0.5,
                                      flexShrink: 0
                                    }}
                                  />
                                  <Box>
                                    <Typography variant="body2" fontWeight={600} color="text.primary">
                                      {em.name}
                                    </Typography>
                                    {scheds.length > 0 ? (
                                      scheds.map((s, idx) => (
                                        <Typography key={idx} variant="caption" color="text.secondary" display="block">
                                          {s.triggerMode === 'date' && s.triggerDate ? (
                                            `Programmé le ${new Date(s.triggerDate).toLocaleString('fr-FR')}`
                                          ) : s.triggerMode === 'interval' && s.triggerInterval ? (
                                            `Programmé après ${s.triggerInterval} ${s.triggerIntervalUnit || ''}`
                                          ) : (
                                            em.publishUp ? `Programmé le ${new Date(em.publishUp).toLocaleDateString('fr-FR')}` : 'Non programmé'
                                          )}
                                        </Typography>
                                      ))
                                    ) : (
                                      <Typography variant="caption" color="text.secondary">
                                        {em.publishUp ? `Programmé le ${new Date(em.publishUp).toLocaleDateString('fr-FR')}` : 'Non programmé'}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                              );
                            })
                          )}
                        </Box>
                      )}
                    </Box>

                  </Box>

                </Box>

              </Box>

            )}



            {tabValue === 2 && (

              <Box sx={{ py: 2 }}>

                    <Stack spacing={2}>

                      <Box>

                        <Typography fontWeight={700} color="#495057" fontFamily="Montserrat, Arial, sans-serif">Description :</Typography>

                                            <Typography color="#495057">{findCampaignById(selected)?.description || "Non spécifiée"}</Typography>

                      </Box>

                      <Box>

                        <Typography fontWeight={700} color="#495057" fontFamily="Montserrat, Arial, sans-serif">Statut :</Typography>

                        <Typography color="#495057">

                          {(() => {

                        const campagne = findCampaignById(selected);

                            if (!campagne) return 'Non renseigné';

                            const statut = getCampagneStatus(campagne);

                            return (

                              <span style={{ color: statut.color, fontWeight: 600 }}>

                                {statut.label}

                              </span>

                            );

                          })()}

                        </Typography>

                      </Box>



                      <Box>

                        <Typography fontWeight={700} color="#495057" fontFamily="Montserrat, Arial, sans-serif">Date de création :</Typography>

                        <Typography color="#495057">

                          {(() => {

                            const campagne = findCampaignById(selected);

                            if (!campagne || !campagne.dateAdded) return 'Non renseignée';

                            const d = new Date(campagne.dateAdded);

                            return d.toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });

                          })()}

                        </Typography>

                      </Box>



                      <Box>

                        <Typography fontWeight={700} color="#495057" fontFamily="Montserrat, Arial, sans-serif">Planification :</Typography>

                        <Typography color="#495057">

                          {(() => {

                        const campagne = findCampaignById(selected);

                            if (!campagne) return 'Non renseigné';

                            const { publishUp, publishDown } = campagne;

                            const formatDate = (dateStr) => {

                              if (!dateStr) return null;

                              const d = new Date(dateStr);

                              // Affichage FR : 27/10/2024 10:00

                              return d.toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });

                            };

                            const debut = formatDate(publishUp);

                            const fin = formatDate(publishDown);

                            if (debut && fin) return `Du ${debut} au ${fin}`;

                            if (debut) return `À partir du ${debut}`;

                            if (fin) return `Jusqu'au ${fin}`;

                            return 'Non planifiée';

                          })()}

                        </Typography>

                      </Box>

                    </Stack>

              </Box>

            )}

                  </Paper>

              ) : (

                <Paper

                  sx={{

                    p: 3,

                    borderRadius: 3,

                    boxShadow: 2,

              height: '100%',

                    display: 'flex',

                    alignItems: 'center',

                    justifyContent: 'center',

                    textAlign: 'center',

                    backgroundColor: '#f8f9fa'

                  }}

                >

                  <Box>

                    <RocketLaunchIcon sx={{ fontSize: 60, color: 'grey.400', mb: 2 }} />

                    <Typography variant="h6" color="textSecondary">

                      Sélectionnez une campagne

                    </Typography>

                    <Typography variant="body1" color="textSecondary">

                      pour afficher ses détails et son analyse de performance.

                    </Typography>

                  </Box>

                </Paper>

              )}

          </Box>

      </Box>



      {/* Action Menu */}

      <Menu

        anchorEl={anchorEl}

        open={Boolean(anchorEl)}

        onClose={handleMenuClose}

        anchorOrigin={{

          vertical: 'bottom',

          horizontal: 'right',

        }}

        transformOrigin={{

          vertical: 'top',

          horizontal: 'right',

        }}

        PaperProps={{

          sx: {

            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',

            border: '1px solid #E5E7EB',

            borderRadius: 2,

            minWidth: 180

          }

        }}

      >

        <MenuItem 

          onClick={() => handleToggleActivate(selectedCampaignId)} 

          disabled={getCampagneStatusLabel(campagnes.find(c => c.id === selectedCampaignId) || {}) === 'Terminée'}

        >

          <ListItemIcon>

            {updatingCampaignId === selectedCampaignId ? (

              <CircularProgress size={20} />

            ) : (

              campagnes.find(c => c.id === selectedCampaignId)?.isPublished ? (

                <ToggleOnIcon fontSize="small" color="success" />

              ) : (

                <ToggleOffIcon fontSize="small" color="warning" />

              )

            )}

          </ListItemIcon>

          {campagnes.find(c => c.id === selectedCampaignId)?.isPublished ? 'Désactiver' : 'Activer'}

        </MenuItem>

        {!HIDE_INCOMPLETE_FEATURES && (
          <MenuItem onClick={() => openDuplicateDialog(selectedCampaignId)}>
            <ListItemIcon>
              <ContentCopyIcon fontSize="small" color="primary" />
            </ListItemIcon>
            Dupliquer
          </MenuItem>
        )}

        <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>

          <ListItemIcon>

            <DeleteIcon fontSize="small" color="error" />

          </ListItemIcon>

          Supprimer

        </MenuItem>

      </Menu>



      {/* Dialogue de confirmation de suppression */}

      <Dialog

        open={deleteDialogOpen}

        onClose={() => setDeleteDialogOpen(false)}

        aria-labelledby="alert-dialog-title"

        aria-describedby="alert-dialog-description"

      >

        <DialogTitle id="alert-dialog-title">

          {"Confirmer la suppression"}

        </DialogTitle>

        <DialogContent>

          <DialogContentText id="alert-dialog-description">

            Êtes-vous sûr de vouloir supprimer la campagne "{campagnes.find(c => c.id === selectedCampaignId)?.name}" ? Cette action est irréversible.

          </DialogContentText>

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setDeleteDialogOpen(false)} disabled={deletingCampaign}>Annuler</Button>

          <Button onClick={confirmDelete} color="error" disabled={deletingCampaign}>

            {deletingCampaign ? <CircularProgress size={24} /> : "Supprimer"}

          </Button>

        </DialogActions>

      </Dialog>



      {/* Dialogue de duplication et renommage */}

      <Dialog open={duplicateDialogOpen} onClose={closeDuplicateDialog} fullWidth maxWidth="sm">

        <DialogTitle>Dupliquer et renommer la campagne</DialogTitle>

        <DialogContent>

          <DialogContentText sx={{ mb: 2 }}>

            Vous vous apprêtez à dupliquer la campagne "{campaignToDuplicate?.name}".

            Veuillez choisir un nouveau nom pour la copie.

          </DialogContentText>

          <TextField

            autoFocus

            margin="dense"

            id="name"

            label="Nouveau nom de la campagne"

            type="text"

            fullWidth

            variant="standard"

            value={newCampaignName}

            onChange={(e) => setNewCampaignName(e.target.value)}

          />

        </DialogContent>

        <DialogActions>

          <Button onClick={closeDuplicateDialog} disabled={!!duplicatingCampaignId}>Annuler</Button>

          <Button onClick={handleDuplicateAndRename} disabled={duplicatingCampaignId !== null || !newCampaignName.trim()}>

            {duplicatingCampaignId === campaignToDuplicate?.id ? <CircularProgress size={24} /> : 'Dupliquer'}

          </Button>

        </DialogActions>

      </Dialog>

      {/* Edit Campaign (Mautic) Modal */}
      <Dialog
        open={editDialogOpen}
        onClose={requestCloseEditDialog}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            height: '90vh',
            maxHeight: '90vh',
            borderRadius: 2,
            overflow: 'hidden',
          },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
              borderBottom: '1px solid #E5E7EB',
              flexShrink: 0,
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              Modifier la campagne
            </Typography>
            <IconButton
              onClick={requestCloseEditDialog}
              sx={{ color: '#6B7280', '&:hover': { color: '#374151' } }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ position: 'relative', flex: 1, minHeight: 0 }}>
            {editIsLoading && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'rgba(255, 255, 255, 0.9)',
                  zIndex: 1,
                }}
              >
                <CircularProgress size={40} sx={{ mb: 2 }} />
                <Typography variant="body2" color="text.secondary">
                  Chargement de l’éditeur de campagne...
                </Typography>
              </Box>
            )}
            {editHasError && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1,
                }}
              >
                <Alert severity="error" sx={{ maxWidth: 400 }}>
                  Erreur lors du chargement de l’éditeur. Veuillez réessayer.
                </Alert>
              </Box>
            )}
            {editIframeSrc && (
              <iframe
                title="Mautic Edit Campaign"
                src={editIframeSrc}
                style={{ border: 'none', width: '100%', height: '100%' }}
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
                onLoad={() => {
                  setEditIsLoading(false);
                  setEditHasError(false);
                }}
                onError={() => {
                  setEditIsLoading(false);
                  setEditHasError(true);
                }}
              />
            )}
          </Box>
        </Box>
      </Dialog>

      {/* Confirmation de fermeture de l'éditeur de campagne */}
      <Dialog
        open={editCloseConfirmOpen}
        onClose={handleCancelCloseEditDialog}
        aria-labelledby="confirm-close-edit-dialog-title"
      >
        <DialogTitle id="confirm-close-edit-dialog-title">
          Fermer l’éditeur de campagne ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Êtes-vous sûr de vouloir fermer l’éditeur de campagne ? Toute modification non enregistrée dans Mautic pourrait être perdue.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelCloseEditDialog}>
            Continuer l’édition
          </Button>
          <Button onClick={handleConfirmCloseEditDialog} color="error" autoFocus>
            Fermer l’éditeur
          </Button>
        </DialogActions>
      </Dialog>



      {/* Notification Snackbar */}

      <Snackbar

        open={notification.open}

        autoHideDuration={4000}

        onClose={handleCloseNotification}

        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}

      >

        <Alert

          onClose={handleCloseNotification}

          severity={notification.severity}

          variant="filled"

          sx={{

            borderRadius: 2,

            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'

          }}

        >

          {notification.message}

        </Alert>

      </Snackbar>



      {/* Creation Modal: choose AI vs Manual */}
      <Dialog open={createDialogOpen} onClose={() => setCreateDialogOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Créer une nouvelle campagne</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, mt: 1 }}>
            <Paper
              variant="outlined"
              sx={{ p: 2, cursor: 'pointer', borderRadius: 2, '&:hover': { borderColor: '#007B8A', bgcolor: '#F0FDFE' } }}
              onClick={() =>
                handleCreateCampaignRequest(() => {
                  setCreateDialogOpen(false);
                  navigate('/campagne/planification');
                })
              }
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1 }}>
                <SmartToyIcon sx={{ fontSize: 36, color: '#007B8A' }} />
                <Typography variant="subtitle1" fontWeight={700}>Création par IA</Typography>
                <Typography variant="body2" color="text.secondary">Générez une campagne avec assistance intelligente.</Typography>
              </Box>
            </Paper>
            <Paper
              variant="outlined"
              sx={{ p: 2, cursor: 'pointer', borderRadius: 2, '&:hover': { borderColor: '#3B82F6', bgcolor: '#EFF6FF' } }}
              onClick={() =>
                handleCreateCampaignRequest(() => {
                  setCreateDialogOpen(false);
                  navigate('/campagne/creation-manuelle');
                })
              }
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1 }}>
                <BuildIcon sx={{ fontSize: 36, color: '#3B82F6' }} />
                <Typography variant="subtitle1" fontWeight={700}>Création manuelle</Typography>
                <Typography variant="body2" color="text.secondary">Ouvrir l'interface Mautic pour créer une campagne.</Typography>
              </Box>
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCreateDialogOpen(false)}>Fermer</Button>
        </DialogActions>
      </Dialog>

      {/* Calendar Modal */}

      <Dialog

        open={calendarModalOpen}

        onClose={() => setCalendarModalOpen(false)}

        maxWidth="xl"

        fullWidth

        PaperProps={{

          sx: {

            height: '90vh',

            maxHeight: '90vh',

            borderRadius: 2,

            overflow: 'hidden'

          }

        }}

      >

        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

          {/* Header */}

          <Box sx={{ 

            display: 'flex', 

            justifyContent: 'space-between', 

            alignItems: 'center', 

            p: 3, 

            borderBottom: '1px solid #E5E7EB',

            flexShrink: 0

          }}>

            <Typography variant="h5" fontWeight={600} color="text.primary">

              Calendrier des Campagnes

            </Typography>

            <IconButton

              onClick={() => setCalendarModalOpen(false)}

              sx={{ color: '#6B7280', '&:hover': { color: '#374151' } }}

            >

              <CloseIcon />

            </IconButton>

          </Box>



          {/* Content */}

          <Box sx={{ display: 'flex', flex: 1, p: 3, gap: 3, overflow: 'hidden', minHeight: 0 }}>

            {calendarLoading && (

              <Box sx={{ 

                position: 'absolute', 

                top: 0, 

                left: 0, 

                right: 0, 

                bottom: 0, 

                bgcolor: 'rgba(255, 255, 255, 0.8)', 

                display: 'flex', 

                alignItems: 'center', 

                justifyContent: 'center',

                zIndex: 1

              }}>

                <CircularProgress />

              </Box>

            )}

            {/* Left Column - Filters & Navigation */}

            <Box sx={{ width: '25%', minWidth: '240px', display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflowY: 'auto' }}>

              {/* New Campaign Button */}

              <Button

                variant="contained"

                startIcon={<AddIcon />}

                onClick={() => handleCreateCampaignRequest(() => navigate('/campagne/planification'))}

                sx={{

                  bgcolor: '#007B8A',

                  color: 'white',

                  '&:hover': { bgcolor: '#006064' },

                  mb: 3

                }}

              >

                Nouvelle Campagne

              </Button>



              {/* Calendar Navigation */}

              <Box sx={{ textAlign: 'center', mb: 3 }}>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>

                  <IconButton 

                    size="small" 

                    sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F4F6' } }}

                    onClick={() => handleCalendarNavigation('prev')}

                    disabled={calendarLoading}

                  >

                    <ChevronLeftIcon />

                  </IconButton>

                  <Typography variant="h6" fontWeight={600} color="text.primary">

                    {new Date(currentCalendarDate.year, currentCalendarDate.month - 1).toLocaleDateString('fr-FR', { 

                      month: 'long', 

                      year: 'numeric' 

                    })}

                  </Typography>

                  <IconButton 

                    size="small" 

                    sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F4F6' } }}

                    onClick={() => handleCalendarNavigation('next')}

                    disabled={calendarLoading}

                  >

                    <ChevronRightIcon />

                  </IconButton>

                </Box>

                

                {/* Days of week */}

                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', mb: 1 }}>

                  {['DI', 'LU', 'MA', 'ME', 'JE', 'VE', 'SA'].map((day) => (

                    <Typography key={day} variant="caption" color="text.secondary" sx={{ py: 0.5 }}>

                      {day}

                    </Typography>

                  ))}

                </Box>

                

                {/* Calendar grid */}

                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 0.5 }}>

                  {generateCalendarDays(currentCalendarDate.year, currentCalendarDate.month).map((dayData, index) => (

                    <Box

                      key={index}

                      sx={{

                        p: 0.5,

                        textAlign: 'center',

                        fontSize: '0.75rem',

                        fontWeight: dayData.isToday ? 'bold' : 'normal',

                        color: dayData.isToday ? 'white' : dayData.isCurrentMonth ? 'text.primary' : 'text.secondary',

                        bgcolor: dayData.isToday ? '#0D9488' : 'transparent',

                        borderRadius: dayData.isToday ? '50%' : 0,

                        width: dayData.isToday ? '24px' : 'auto',

                        height: dayData.isToday ? '24px' : 'auto',

                        display: 'flex',

                        alignItems: 'center',

                        justifyContent: 'center',

                        mx: 'auto',

                        position: 'relative'

                      }}

                    >

                      {dayData.day}

                      {dayData.campaigns.length > 0 && (

                        <Box

                          sx={{

                            position: 'absolute',

                            top: '-2px',

                            right: '-2px',

                            width: '8px',

                            height: '8px',

                            borderRadius: '50%',

                            bgcolor: '#8B5CF6'

                          }}

                        />

                      )}

                    </Box>

                  ))}

                </Box>

              </Box>



              {/* Today's Campaigns */}

              <Box sx={{ mb: 3, pt: 2, borderTop: '1px solid #E5E7EB' }}>

                <Typography variant="h6" fontWeight={600} color="text.primary" mb={2}>

                  Campagnes non stop

                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, maxHeight: '220px', overflowY: 'auto', pr: 1 }}>

                  {(() => {
                    const filtered = (calendarOngoingNoEnd || []).filter(doesCampaignMatchCalendarFilter);

                    if (filtered.length === 0) {
                      return (
                        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                          Aucune campagne active sans date de fin
                        </Typography>
                      );
                    }

                    return filtered.map((item, index) => {
                      const base = item.campaign || item;
                      const statut = getCampagneStatus(base);
                      return (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                          <Box
                            sx={{
                              width: '10px',
                              height: '10px',
                              borderRadius: '50%',
                              bgcolor: statut.color,
                              mt: 0.5,
                              flexShrink: 0
                            }}
                          />
                          <Box>
                            <Typography variant="body2" fontWeight={600} color="text.primary">
                              {base.name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {statut.label}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    });
                  })()}

                </Box>

              </Box>



              {/* Status Filters */}

              <Box sx={{ mt: 'auto', pt: 2, borderTop: '1px solid #E5E7EB' }}>

                <Typography variant="caption" sx={{ 

                  fontWeight: 600, 

                  textTransform: 'uppercase', 

                  color: '#9CA3AF', 

                  display: 'block',

                  mb: 2,

                  px: 1

                }}>

                  Statuts

                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  {[{ id: 'all', label: 'Toutes', color: '#6B7280' }, ...statusFilters].map((item) => (
                    <Box
                      key={item.id}
                      onClick={() => setCalendarStatusFilter(item.id)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        py: 2,
                        px: 3,
                        borderRadius: 2,
                        cursor: 'pointer',
                        bgcolor: calendarStatusFilter === item.id ? 'rgba(59, 130, 246, 0.06)' : 'transparent',
                        '&:hover': {
                          bgcolor: 'rgba(59, 130, 246, 0.08)',
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <Box
                        sx={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          bgcolor: item.color,
                          flexShrink: 0
                        }}
                      />
                      <Typography sx={{ fontSize: '0.875rem', fontWeight: 600, color: calendarStatusFilter === item.id ? '#111827' : 'inherit' }}>
                        {item.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>

              </Box>

            </Box>



            {/* Right Column - Main Calendar */}

            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflowY: 'auto' }}>

              {/* Calendar Header */}

              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexShrink: 0 }}>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                  <Button

                    variant="outlined"

                    size="small"

                    onClick={handleCalendarToday}

                    disabled={calendarLoading}

                    sx={{ 

                      borderColor: '#D1D5DB', 

                      color: '#374151',

                      '&:hover': { bgcolor: '#F9FAFB' }

                    }}

                  >

                    Aujourd'hui

                  </Button>

                  <IconButton 

                    size="small" 

                    sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F4F6' } }}

                    onClick={() => handleCalendarNavigation('prev')}

                    disabled={calendarLoading}

                  >

                    <ChevronLeftIcon />

                  </IconButton>

                  <IconButton 

                    size="small" 

                    sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F4F6' } }}

                    onClick={() => handleCalendarNavigation('next')}

                    disabled={calendarLoading}

                  >

                    <ChevronRightIcon />

                  </IconButton>

                  <Typography variant="h5" fontWeight={600} color="text.primary" sx={{ ml: 1 }}>

                    {new Date(currentCalendarDate.year, currentCalendarDate.month - 1).toLocaleDateString('fr-FR', { 

                      month: 'long', 

                      year: 'numeric' 

                    })}

                  </Typography>

                </Box>

                

                {/* View Toggle */}

                <Box sx={{ 

                  display: 'flex', 

                  alignItems: 'center', 

                  border: '1px solid #D1D5DB', 

                  borderRadius: 2,

                  p: 0.5

                }}>
                  <Button
                    variant={calendarView === 'month' ? 'contained' : 'text'}
                    size="small"
                    onClick={() => setCalendarView('month')}
                    sx={{ 
                      bgcolor: calendarView === 'month' ? '#007B8A' : 'transparent', 
                      color: calendarView === 'month' ? 'white' : '#374151',
                      boxShadow: 'none',
                      '&:hover': { bgcolor: calendarView === 'month' ? '#006064' : '#F3F4F6' }
                    }}
                  >
                    Mois
                  </Button>
                  <Button
                    variant={calendarView === 'week' ? 'contained' : 'text'}
                    size="small"
                    onClick={() => setCalendarView('week')}
                    sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F4F6' } }}
                  >
                    Semaine
                  </Button>
                  <Button
                    variant={calendarView === 'day' ? 'contained' : 'text'}
                    size="small"
                    onClick={() => setCalendarView('day')}
                    sx={{ color: '#6B7280', '&:hover': { bgcolor: '#F3F4F6' } }}
                  >
                    Jour
                  </Button>
                </Box>

              </Box>



              {/* Calendar Grid */}

              {(calendarView === 'month' || calendarView === 'week') && (() => {
                let days;
                
                if (calendarView === 'month') {
                  // Vue mois : afficher tous les jours du mois actuel
                  const year = selectedDate.getFullYear();
                  const month = selectedDate.getMonth();
                  const firstDayOfMonth = new Date(year, month, 1);
                  const lastDayOfMonth = new Date(year, month + 1, 0);
                  const daysInMonth = lastDayOfMonth.getDate();
                  
                  // Calculer le premier jour de la grille (dimanche de la première semaine)
                  const firstDayOfWeek = firstDayOfMonth.getDay(); // 0 = dimanche, 1 = lundi, etc.
                  const startDate = new Date(firstDayOfMonth);
                  startDate.setDate(firstDayOfMonth.getDate() - firstDayOfWeek);
                  
                  // Calculer le nombre total de jours à afficher (semaines complètes)
                  const totalDays = Math.ceil((firstDayOfWeek + daysInMonth) / 7) * 7;
                  
                  days = Array.from({ length: totalDays }, (_, i) => {
                    const nd = new Date(startDate);
                    nd.setDate(startDate.getDate() + i);
                    const y = nd.getFullYear();
                    const m = String(nd.getMonth() + 1).padStart(2, '0');
                    const dd = String(nd.getDate()).padStart(2, '0');
                    const key = `${y}-${m}-${dd}`;
                    return { date: nd, key };
                  });
                } else {
                  // Vue semaine : afficher la semaine actuelle
                  const base = new Date(selectedDate);
                  const dow = base.getDay();
                  const mondayOffset = (dow === 0 ? -6 : 1 - dow);
                  const start = new Date(base);
                  start.setDate(base.getDate() + mondayOffset);
                  
                  days = Array.from({ length: 7 }, (_, i) => {
                    const nd = new Date(start);
                    nd.setDate(start.getDate() + i);
                    const y = nd.getFullYear();
                    const m = String(nd.getMonth() + 1).padStart(2, '0');
                    const dd = String(nd.getDate()).padStart(2, '0');
                    const key = `${y}-${m}-${dd}`;
                    return { date: nd, key };
                  });
                }
                
                return (
                  <Box sx={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', borderTop: '1px solid #E5E7EB', borderLeft: '1px solid #E5E7EB', bgcolor: 'white' }}>
                    {['DIM','LUN','MAR','MER','JEU','VEN','SAM'].map((label) => (
                      <Box key={label} sx={{ py: 1, textAlign: 'center', fontSize: '0.75rem', fontWeight: 600, color: '#6B7280', borderRight: '1px solid #E5E7EB', borderBottom: '1px solid #E5E7EB', bgcolor: '#F9FAFB' }}>{label}</Box>
                    ))}
                    {days.map((item, idx) => {
                      const items = (calendarData[item.key] || []).filter(doesCampaignMatchCalendarFilter);
                      const isToday = new Date().toDateString() === item.date.toDateString();
                      const isCurrentMonth = item.date.getMonth() === selectedDate.getMonth();
                      
                      return (
                        <Box key={idx} sx={{ 
                          p: 1, 
                          borderRight: '1px solid #E5E7EB', 
                          borderBottom: '1px solid #E5E7EB', 
                          minHeight: calendarView === 'week' ? '200px' : '120px', 
                          position: 'relative', 
                          bgcolor: 'white',
                          opacity: calendarView === 'month' && !isCurrentMonth ? 0.3 : 1
                        }}>
                          <Typography variant="body2" sx={{ 
                            fontWeight: isToday ? 'bold' : 'normal', 
                            color: isToday ? 'white' : (calendarView === 'month' && !isCurrentMonth ? '#9CA3AF' : 'text.primary'), 
                            bgcolor: isToday ? '#0D9488' : 'transparent', 
                            borderRadius: isToday ? '50%' : 0, 
                            width: isToday ? '24px' : 'auto', 
                            height: isToday ? '24px' : 'auto', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            mb: 1 
                          }}>
                            {item.date.getDate()}
                          </Typography>
                          {items.map((campaign, i2) => {
                            const statut = getCampagneStatus(campaign.campaign || campaign);
                            return (
                              <Box key={i2} sx={{ 
                                fontSize: '0.75rem', 
                                bgcolor: statut.color, 
                                color: 'white', 
                                px: 1, 
                                py: 0.5, 
                                borderRadius: 1, 
                                fontWeight: 600, 
                                mb: 0.5, 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis', 
                                whiteSpace: 'nowrap' 
                              }} title={`${campaign.name} • ${statut.label}`}>
                                {campaign.name}
                              </Box>
                            );
                          })}
                        </Box>
                      );
                    })}
                  </Box>
                );
              })()}

              {calendarView === 'day' && (() => {
                const y = selectedDate.getFullYear();
                const m = String(selectedDate.getMonth() + 1).padStart(2, '0');
                const d = String(selectedDate.getDate()).padStart(2, '0');
                const key = `${y}-${m}-${d}`;
                const items = (calendarData[key] || []).filter(doesCampaignMatchCalendarFilter);
                return (
                  <Box sx={{ flex: 1, p: 2 }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                      {selectedDate.toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                    </Typography>
                    {items.length === 0 ? (
                      <Typography variant="body2" color="text.secondary">Aucun événement</Typography>
                    ) : (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                        {items.map((item, idx) => {
                          const base = item.campaign || item;
                          const statut = getCampagneStatus(base);
                          return (
                            <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                              <Box sx={{ width: '10px', height: '10px', borderRadius: '50%', bgcolor: statut.color, mt: 0.5, flexShrink: 0 }} />
                              <Box>
                                <Typography variant="body2" fontWeight={600}>{base.name}</Typography>
                                <Typography variant="caption" color="text.secondary">{statut.label}</Typography>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    )}
                  </Box>
                );
              })()}

              {/* Vue par défaut si aucune vue n'est sélectionnée */}
              {!['month', 'week', 'day'].includes(calendarView) && (() => {
                // Forcer la vue mois par défaut
                return (
                  <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography variant="body2" color="text.secondary">
                      Chargement de la vue mois...
                    </Typography>
                  </Box>
                );
              })()}

            </Box>

          </Box>

        </Box>

      </Dialog>

    </Box>

  );

};



export default Campagne;